import React, { useContext } from 'react';
// import moment from 'moment';
import { toast } from 'react-toastify';
import { renderToString } from 'react-dom/server';
import h2p from 'html2plaintext';

import {
  Row,
  Col,
  Accordion,
  Button,
  Form,
  InputGroup,
  Image,
  Dropdown,
  DropdownButton,
  Stack,
  Modal,
  Offcanvas,
  Tabs,
  Tab,
  Badge,
  Nav,
  ButtonGroup,
} from 'react-bootstrap';
import styled from 'styled-components';

import { 
  Tooltip,
  Popover,
  Checkbox,
  Radio,
  Switch,
  Progress,
  Alert,
  Avatar,
} from 'antd';
import type { UploadFile } from 'antd';

import CurrencyInput from 'react-currency-input-field';
import InputMask from 'react-input-mask';
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import RangePicker from "../../components/dateRangePicker/DateRangePicker.jsx";

// Auth
// import { useAuthContext } from '../../auth/use-auth-context.js';
// import { useRouter } from '../../auth/auth-guard.js';

// Redux
import { useDispatch } from 'react-redux';
import { RootState, AppDispatch, useTypedSelector, Tables } from '../../utils/store.tsx';
// import testSlice from '../../utils/slice/testSlice.tsx';
// import { } from '../customers/slice.tsx';

import imagePreviewSlice from '../../components/imagePreview/imagePreviewSlice';
import ImagePreview from '../../components/imagePreview/ImagePreview.tsx'

// enums
import { Permissions } from '../../utils/enums.tsx';
import { dateFormat, timeFormat, dateTimeFormat, getDateObjectTime, getDateRanges, info, success, warning, danger, getAddressPlace, escapeChars, escapeCharsInStringOnPaste, createEditorState, isNumeric } from '../../utils/utils.tsx';

// components
import MainContainer from '../../components/container/MainContainer.jsx';
import { CustomToggle, CustomMenu } from '../../components/dropdown/Dropdown.jsx';
import Select from '../../components/select/Select.tsx';
import SmartSelect from '../../components/select/SmartSelect.tsx';
import Autocomplete from '../../components/autocomplete/Autocomplete.tsx';
import SmartAutocomplete from '../../components/autocomplete/SmartAutocomplete.tsx';
import EditTitle from '../../components/popover/EditTitle.tsx';
import EditTimeZone from '../../components/popover/EditTimeZone.tsx';
import ColorPicker from '../../components/colorPicker/ColorPicker.tsx';
import GoogleSearchAddress from '../../components/googleMap/GoogleSearchAddress.jsx';
import Dropzone from '../../components/dropzone/Dropzone.tsx';
import LocalDropzone from '../../components/dropzone/LocalDropzone.tsx';

import MaterialDataTable from '../../components/table/withSlice/MaterialDataTable.jsx';
// import DataTable from '../../components/table/DataTable.tsx';
// import DataTable, { IndeterminateCheckbox } from '../../components/table/DataTableOLD.tsx';
import DataTableVisibility from '../../components/table/withSlice/DataTableVisibility.tsx';
import createGenericSlice from '../../components/table/withSlice/tableSlice.tsx';
import TableActions from '../../components/popover/TableActions.tsx';
import TableFilter from '../../components/popover/TableFilter.tsx';
import DefaultPopup from '../../components/popover/DefaultPopup.tsx';
import RTextEditor from '../../components/richTextEditor/RTextEditor.jsx';

import { ReactComponent as EditIcon } from "../../assets/icons/edit.svg";
import { ReactComponent as BellIcon } from "../../assets/icons/bell.svg";
import { ReactComponent as EyeIcon } from "../../assets/icons/eye.svg";
import { ReactComponent as MapPinIcon } from "../../assets/icons/map-pin.svg";
import { ReactComponent as Edit2Icon } from "../../assets/icons/edit-2.svg";
import { ReactComponent as Trash2Icon } from "../../assets/icons/trash-2.svg";
import { ReactComponent as PlusIcon } from "../../assets/icons/plus.svg";
import { ReactComponent as MinusIcon } from "../../assets/icons/minus.svg";
import { ReactComponent as CopyIcon } from "../../assets/icons/copy.svg";
import { ReactComponent as CalendarIcon } from "../../assets/icons/calendar.svg";
import { ReactComponent as ClockIcon } from "../../assets/icons/clock.svg";
import { ReactComponent as SettingsIcon } from "../../assets/icons/settings.svg";
import { ReactComponent as SearchIcon } from "../../assets/icons/search.svg";
import { ReactComponent as CheckboxUncheckedIcon } from "../../assets/icons/checkbox-unchecked.svg";
import { ReactComponent as CheckboxCheckedIcon } from "../../assets/icons/checkbox-checked.svg";
import { ReactComponent as AlertInfoIcon } from "../../assets/icons/alert-info.svg";
import { ReactComponent as AlertCircleIcon } from "../../assets/icons/alert-circle.svg";
import { ReactComponent as AlertTriangleIcon } from "../../assets/icons/alert-triangle.svg";
import { ReactComponent as AlertCheckIcon } from "../../assets/icons/alert-check.svg";
import { ReactComponent as DownArrowIcon } from "../../assets/icons/chevron-down.svg";

const  DefaultImage = require("../../assets/img/default_image.png") as string;

// ----------------------------------------------------------------------

const StyledSmallerImage = styled(Image)`
  width: 28px;
  height: 28px;
  margin-left: 8px;
`;
const StyledImage = styled(Image)`
  width: 32px;
  height: 32px;
`;
const StyledBiggerImage = styled(Image)`
  width: 56px;
  height: 56px;
`;

const StyledBell = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 105px;
  padding: 7px;
  position: relative;
  background-color: var(--basewhite);
  border-radius: 6px;
  overflow: hidden;
`;
const StyledBellIcon = styled(BellIcon)`
  position: relative;
  width: 16px;
  height: 16px;
`;
const StyledBellLabel = styled.div`
  display: flex;
  flex-direction: column;
  width: 10px;
  height: 10px;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0px 5px;
  position: absolute;
  top: 5px;
  left: 13px;
  background-color: #CB3A31;
  border-radius: 50px;

  .text-wrapper {
    position: relative;
    width: fit-content;
    margin-left: -2px;
    margin-right: -2px;
    font-family: "Inter-SemiBold", Helvetica;
    font-weight: 600;
    color: white;
    font-size: 6px;
    letter-spacing: -0.18px;
    line-height: 8px;
    white-space: nowrap;
  }
`;

// ----------------------------------------------------------------------

const tableAlerts = createGenericSlice<any>(Tables.Alerts);

const DesignSystemPage = () => {
  // const { logout }: any = useAuthContext();
  // const router = useRouter();

  // const { item } = useTypedSelector((state: RootState) => state.testSlice);
  // const dispatch = useDispatch<AppDispatch>();

  const { searchQuery, isIncludeInactive, isInactive } = useTypedSelector((state: RootState) => state.tableAlerts);
  const dispatch = useDispatch<AppDispatch>();


  // React.useEffect(() => {
  //   dispatch(testSlice.calApi())
  // }, []);

  
  const [selectedColor, setSelectedColor] = React.useState('#9179ED');

  const [selectedDate, setSelectedDate] = React.useState('');
  const [selectedTime, setSelectedTime] = React.useState('');
  const [selectedDateTime, setSelectedDateTime] = React.useState('');
  const [ranges, setRanges] = React.useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection'
    }
  ]);

  
  const [showOffcanvas1, setShowOffcanvas1] = React.useState(false);
  const [showOffcanvas2, setShowOffcanvas2] = React.useState(false);

  
  const [selectValueId, setSelectValueId] = React.useState<any>(18);
  const [selectValueName, setSelectValueName] = React.useState('3asd');

  const [selectDriverValueId, setSelectDriverValueId] = React.useState<Array<any>>([300, 285]);
  const [selectDriverValueName, setSelectDriverValueName] = React.useState<Array<any>>(['Driver 5', 'Driver 2']);

  let msg = '';
  let msgHTML = msg;
  let msgPlainText = h2p(msg);
  let msgEditorState = createEditorState(msg);
  const [messagePlainText, setMessagePlainText] = React.useState(msgPlainText);
  const [messageHTML, setMessageHTML] = React.useState(msgHTML);
  const [messageEditorState, setMessageEditorState] = React.useState(msgEditorState);


  const [isActive, setIsActive] = React.useState<any>(1);
  const [dataTable, setDataTable] = React.useState(null);
  const columnsRender = [
    {
      id: 'customerCategoryName',
      Cell: ({ renderedCellValue, row }: any) => {
        let item = (row.original && row.original.category) ? row.original.category : null;
        return (item && item.customerCategoryName && item.customerCategoryName != '') ? item.customerCategoryName : ''
      }
    },
    {
      id: 'isActive',
      Cell: ({ renderedCellValue, row }: any) => {
        return (renderedCellValue == true) ? <Badge bg={'custom-success'}>Active</Badge> : <Badge bg={'custom-danger'}>Inactive</Badge>
      }
    },
    {
      id: 'actions',
      Cell: ({ renderedCellValue, row }: any) => {
        return <div className='text-center'>
          <TableActions disabled={false}>
            <Dropdown.Item
              onClick={() => {
                
              }}
            >
              <EditIcon />
              <span className={'ps-2'}>Edit customer</span>
            </Dropdown.Item>
          </TableActions>
        </div>
      }
    },
  ];
  const columns = [
    {
      id: 'customerName',
      accessorKey: 'customerName',
      columnDefType: 'data',
      header: 'Customer Name',
      enableHiding: false,
    },
    {
      id: 'billingAddress',
      accessorKey: 'billingAddress',
      columnDefType: 'data',
      header: 'billing Address',
    },
    {
      id: 'customerCategoryName',
      accessorKey: 'customerCategoryName',
      columnDefType: 'data',
      header: 'Category',
    },
    {
      id: 'emailAddresses',
      accessorKey: 'emailAddresses',
      columnDefType: 'data',
      header: 'Email ddress',
    },
    {
      id: 'contactNumber',
      accessorKey: 'contactNumber',
      columnDefType: 'data',
      header: 'Phone Number',
    },
    {
      id: 'billingProfileName',
      accessorKey: 'billingProfileName',
      columnDefType: 'data',
      header: 'Billing By',
    },
    {
      id: 'isActive',
      accessorKey: 'isActive',
      columnDefType: 'data',
      header: 'Status',
    },
    {
      id: 'actions',
      accessorKey: 'actions',
      columnDefType: 'data',
      header: '',
      enableColumnOrdering: false,
      enableSorting: false,
      enableResizing: false,
      enableHiding: false,
      size: 70,
    },
  ];


  const [multipleFileList, setMultipleFileList] = React.useState<UploadFile[]>([
    {
      uid: '1',
      name: 'image.png',
      status: 'done',
      url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
    },
    {
      uid: '2',
      name: 'image.png',
      status: 'done',
      url: 'https://gw.alipayobjects.com/zos/antfincdn/LlvErxo8H9/photo-1503185912284-5271ff81b9a8.webp',
    },
    {
      uid: '3',
      name: 'image.png',
      status: 'done',
      url: 'https://gw.alipayobjects.com/zos/antfincdn/cV16ZqzMjW/photo-1473091540282-9b846e7965e3.webp',
    },
    {
      uid: '4',
      percent: 50,
      name: 'image.png',
      status: 'uploading',
      url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
    },
    {
      uid: '5',
      name: 'image.png',
      status: 'error',
    },
  ]);
  const [threeFileList, setThreeFileList] = React.useState<UploadFile[]>([
    {
      uid: '6',
      name: 'image.png',
      status: 'done',
      url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
    },
    {
      uid: '7',
      name: 'image.png',
      status: 'done',
      url: 'https://gw.alipayobjects.com/zos/antfincdn/x43I27A55%26/photo-1438109491414-7198515b166b.webp',
    },
  ]);
  const [singleFileList, setSingleFileList] = React.useState<UploadFile[]>([]);

  const [photos, setPhotos] = React.useState<any>([
    'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
    'https://gw.alipayobjects.com/zos/antfincdn/LlvErxo8H9/photo-1503185912284-5271ff81b9a8.webp',
    'https://gw.alipayobjects.com/zos/antfincdn/cV16ZqzMjW/photo-1473091540282-9b846e7965e3.webp',
    'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png'
  ]);


  const [valuePlusMinus, setValuePlusMinus] = React.useState<any>(1);


  return <MainContainer title={'Design System'} roles={[ Permissions.All ]} env={'staging'}>
    <Row>
      <Col xs={12} className={'py-3'}>

        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Collor-Palette">
            <Accordion.Header>Collor Palette</Accordion.Header>
            <Accordion.Body>
              <div className={'mb-5'}>
                <div className='bold mb-1'>Base</div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-white)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>white</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-black)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>black</div>
                </div>
              </div>

              <div className={'mb-5'}>
                <div className='bold mb-1'>Neutral</div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-gray-50)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Neutral 50</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-gray-100)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Neutral 100</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-gray-200)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Neutral 200</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-gray-300)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Neutral 300</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-gray-400)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Neutral 400</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-gray-500)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Neutral 500</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-gray-600)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Neutral 600</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-gray-700)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Neutral 700</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-gray-800)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Neutral 800</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-gray-900)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Neutral 900</div>
                </div>
              </div>

              <div className={'mb-2'}>
                <div className='bold mb-1'>Blue (Primary)</div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-blue-50)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Blue 50</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-blue-100)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Blue 100</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-blue-200)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Blue 200</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-blue-300)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Blue 300</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-blue-400)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Blue 400</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-blue-500)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Blue 500</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-blue-600)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Blue 600</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-blue-700)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Blue 700</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-blue-800)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Blue 800</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-blue-900)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Blue 900</div>
                </div>
              </div>
              <div className={'mb-5'}>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-blue-focus1)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Focus 1</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-blue-focus2)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Focus 2</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-blue-focus3)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Focus 3</div>
                </div>
              </div>

              <div className={'mb-2'}>
                <div className='bold mb-1'>Danger</div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-red-50)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Danger 50</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-red-100)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Danger 100</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-red-200)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Danger 200</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-red-300)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Danger 300</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-red-400)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Danger 400</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-red-500)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Danger 500</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-red-600)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Danger 600</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-red-700)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Danger 700</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-red-800)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Danger 800</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-red-900)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Danger 900</div>
                </div>
              </div>
              <div className={'mb-5'}>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-red-focus1)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Focus 1</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-red-focus2)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Focus 2</div>
                </div>
              </div>

              <div className={'mb-2'}>
                <div className='bold mb-1'>Warning</div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-yellow-50)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Warning 50</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-yellow-100)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Warning 100</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-yellow-200)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Warning 200</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-yellow-300)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Warning 300</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-yellow-400)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Warning 400</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-yellow-500)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Warning 500</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-yellow-600)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Warning 600</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-yellow-700)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Warning 700</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-yellow-800)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Warning 800</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-yellow-900)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Warning 900</div>
                </div>
              </div>
              <div className={'mb-5'}>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-yellow-focus1)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Focus 1</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-yellow-focus2)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Focus 2</div>
                </div>
              </div>

              <div className={'mb-2'}>
                <div className='bold mb-1'>Success</div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-green-50)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Success 50</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-green-100)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Success 100</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-green-200)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Success 200</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-green-300)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Success 300</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-green-400)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Success 400</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-green-500)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Success 500</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-green-600)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Success 600</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-green-700)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Success 700</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-green-800)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Success 800</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-green-900)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Success 900</div>
                </div>
              </div>
              <div className={'mb-5'}>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-green-focus1)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Focus 1</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-green-focus2)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Focus 2</div>
                </div>
              </div>

              <div className={'mb-2'}>
                <div className='bold mb-1'>Info</div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-cyan-50)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Info 50</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-cyan-100)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Info 100</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-cyan-200)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Info 200</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-cyan-300)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Info 300</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-cyan-400)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Info 400</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-cyan-500)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Info 500</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-cyan-600)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Info 600</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-cyan-700)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Info 700</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-cyan-800)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Info 800</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-cyan-900)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Info 900</div>
                </div>
              </div>
              <div className={'mb-5'}>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-cyan-focus1)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Focus 1</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-cyan-focus2)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Focus 2</div>
                </div>
              </div>

              <div className={'mb-2'}>
                <div className='bold mb-1'>Purple</div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-purple-50)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Purple 50</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-purple-100)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Purple 100</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-purple-200)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Purple 200</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-purple-300)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Purple 300</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-purple-400)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Purple 400</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-purple-500)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Purple 500</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-purple-600)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Purple 600</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-purple-700)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Purple 700</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-purple-800)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Purple 800</div>
                </div>
                <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                  <div style={{ width: '100px', height: '100px', backgroundColor: 'var(--bs-purple-900)' }} className='border rounded'>&nbsp;</div>
                  <div className='text-center'>Purple 900</div>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Typography">
            <Accordion.Header>Typography</Accordion.Header>
            <Accordion.Body>
              <h1 className='bold'>Display <small>- Inter 60 Bold</small></h1>
              <code>{renderToString(<h1 className='bold'>Display</h1>)}</code>
              <hr />

              <h1 className='semibold'>Display <small>- Inter 60 Semi Bold</small></h1>
              <code>{renderToString(<h1 className='semibold'>Display</h1>)}</code>
              <hr />

              <h1 className='medium'>Display <small>- Inter 60 Medium</small></h1>
              <code>{renderToString(<h1 className='medium'>Display</h1>)}</code>
              <hr />

              <h1>Display <small>- Inter 60 Regular</small></h1>
              <code className='mb-5'>{renderToString(<h1>Display</h1>)}</code>
              <hr />

              
              <h2 className='bold'>Display <small>- Inter 44 Bold</small></h2>
              <code>{renderToString(<h2 className='bold'>Display</h2>)}</code>
              <hr />

              <h2 className='semibold'>Display <small>- Inter 44 Semi Bold</small></h2>
              <code>{renderToString(<h2 className='semibold'>Display</h2>)}</code>
              <hr />

              <h2 className='medium'>Display <small>- Inter 44 Medium</small></h2>
              <code>{renderToString(<h2 className='medium'>Display</h2>)}</code>
              <hr />

              <h2>Display <small>- Inter 44 Regular</small></h2>
              <code className='mb-5'>{renderToString(<h2>Display</h2>)}</code>
              <hr />

              
              <h3 className='bold'>Display <small>- Inter 36 Bold</small></h3>
              <code>{renderToString(<h3 className='bold'>Display</h3>)}</code>
              <hr />

              <h3 className='semibold'>Display <small>- Inter 36 Semi Bold</small></h3>
              <code>{renderToString(<h3 className='semibold'>Display</h3>)}</code>
              <hr />

              <h3 className='medium'>Display <small>- Inter 36 Medium</small></h3>
              <code>{renderToString(<h3 className='medium'>Display</h3>)}</code>
              <hr />

              <h3>Display <small>- Inter 36 Regular</small></h3>
              <code className='mb-5'>{renderToString(<h3>Display</h3>)}</code>
              <hr />

              
              <h4 className='bold'>Display <small>- Inter 28 Bold</small></h4>
              <code>{renderToString(<h4 className='bold'>Display</h4>)}</code>
              <hr />

              <h4 className='semibold'>Display <small>- Inter 28 Semi Bold</small></h4>
              <code>{renderToString(<h4 className='semibold'>Display</h4>)}</code>
              <hr />

              <h4 className='medium'>Display <small>- Inter 28 Medium</small></h4>
              <code>{renderToString(<h4 className='medium'>Display</h4>)}</code>
              <hr />

              <h4>Display <small>- Inter 28 Regular</small></h4>
              <code className='mb-5'>{renderToString(<h4>Display</h4>)}</code>
              <hr />

              
              <h5 className='bold'>Display <small>- Inter 24 Bold</small></h5>
              <code>{renderToString(<h5 className='bold'>Display</h5>)}</code>
              <hr />

              <h5 className='semibold'>Display <small>- Inter 24 Semi Bold</small></h5>
              <code>{renderToString(<h5 className='semibold'>Display</h5>)}</code>
              <hr />

              <h5 className='medium'>Display <small>- Inter 24 Medium</small></h5>
              <code>{renderToString(<h5 className='medium'>Display</h5>)}</code>
              <hr />

              <h5>Display <small>- Inter 24 Regular</small></h5>
              <code className='mb-5'>{renderToString(<h5>Display</h5>)}</code>
              <hr />

              
              <h6 className='bold'>Display <small>- Inter 20 Bold</small></h6>
              <code>{renderToString(<h6 className='bold'>Display</h6>)}</code>
              <hr />

              <h6 className='semibold'>Display <small>- Inter 20 Semi Bold</small></h6>
              <code>{renderToString(<h6 className='semibold'>Display</h6>)}</code>
              <hr />

              <h6 className='medium'>Display <small>- Inter 20 Medium</small></h6>
              <code>{renderToString(<h6 className='medium'>Display</h6>)}</code>
              <hr />

              <h6>Display <small>- Inter 20 Regular</small></h6>
              <code className='mb-5'>{renderToString(<h6>Display</h6>)}</code>
              <hr />

              
              <div><span className='large bold'>Display <small>- Inter 18 Bold</small></span></div>
              <code>{renderToString(<span className='large bold'>Display</span>)}</code>
              <hr />

              <div><span className='large semibold'>Display <small>- Inter 18 Semi Bold</small></span></div>
              <code>{renderToString(<span className='large semibold'>Display</span>)}</code>
              <hr />

              <div><span className='large medium'>Display <small>- Inter 18 Medium</small></span></div>
              <code>{renderToString(<span className='large medium'>Display</span>)}</code>
              <hr />

              <div><span className='large'>Display <small>- Inter 18 Regular</small></span></div>
              <code className='mb-5'>{renderToString(<span className='large'>Display</span>)}</code>
              <hr />


              <div><span className='fs-16 bold'>Display <small>- Inter 16 Bold</small></span></div>
              <code>{renderToString(<span className='fs-16 bold'>Display</span>)}</code>
              <hr />

              <div><span className='fs-16 semibold'>Display <small>- Inter 16 Semi Bold</small></span></div>
              <code>{renderToString(<span className='fs-16 semibold'>Display</span>)}</code>
              <hr />

              <div><span className='fs-16 medium'>Display <small>- Inter 16 Medium</small></span></div>
              <code>{renderToString(<span className='fs-16 medium'>Display</span>)}</code>
              <hr />

              <div><span className='fs-16'>Display <small>- Inter 16 Regular</small></span></div>
              <code className='mb-5'>{renderToString(<span className='fs-16'>Display</span>)}</code>
              <hr />


              <div><span className='bold'>Display <small>- Inter 14 Bold</small></span></div>
              <code>{renderToString(<span className='bold'>Display</span>)}</code>
              <hr />

              <div><span className='semibold'>Display <small>- Inter 14 Semi Bold</small></span></div>
              <code>{renderToString(<span className='semibold'>Display</span>)}</code>
              <hr />

              <div><span className='medium'>Display <small>- Inter 14 Medium</small></span></div>
              <code>{renderToString(<span className='medium'>Display</span>)}</code>
              <hr />

              <div><span>Display <small>- Inter 14 Regular</small></span></div>
              <code className='mb-5'>{renderToString(<span>Display</span>)}</code>
              <hr />


              <div><small className='bold'>Display <small>- Inter 12 Bold</small></small></div>
              <code>{renderToString(<small className='bold'>Display</small>)}</code>
              <hr />

              <div><small className='semibold'>Display <small>- Inter 12 Semi Bold</small></small></div>
              <code>{renderToString(<small className='semibold'>Display</small>)}</code>
              <hr />

              <div><small className='medium'>Display <small>- Inter 12 Medium</small></small></div>
              <code>{renderToString(<small className='medium'>Display</small>)}</code>
              <hr />

              <div><small>Display <small>- Inter 12 Regular</small></small></div>
              <code className='mb-5'>{renderToString(<small>Display</small>)}</code>
              <hr />


              <div className={'xsmall bold'}>Display <small>- Inter 11 Bold</small></div>
              <code>{renderToString(<span className='xsmall bold'>Display</span>)}</code>
              <hr />

              <div className={'xsmall semibold'}>Display <small>- Inter 11 Semi Bold</small></div>
              <code>{renderToString(<span className='xsmall semibold'>Display</span>)}</code>
              <hr />

              <div className={'xsmall medium'}>Display <small>- Inter 11 Medium</small></div>
              <code>{renderToString(<span className='xsmall medium'>Display</span>)}</code>
              <hr />

              <div className={'xsmall'}>Display <small>- Inter 11 Regular</small></div>
              <code className='mb-5'>{renderToString(<span className='xsmall'>Display</span>)}</code>
              <hr />


              <div><a href={'/'} className='bold'>Display <small>- Inter 14 Bold</small></a></div>
              <code>{renderToString(<a href={'/'} className='bold'>Display</a>)}</code>
              <hr />

              <div><a href={'/'} className='semibold'>Display <small>- Inter 14 Semi Bold</small></a></div>
              <code>{renderToString(<a href={'/'} className='semibold'>Display</a>)}</code>
              <hr />

              <div><a href={'/'} className='medium'>Display <small>- Inter 14 Medium</small></a></div>
              <code>{renderToString(<a href={'/'} className='medium'>Display</a>)}</code>
              <hr />

              <div><a href={'/'}>Display <small>- Inter 14 Regular</small></a></div>
              <code className='mb-5'>{renderToString(<a href={'/'}>Display</a>)}</code>
              <hr />
              

              <div><a href={'/'} className='bold hover'>Display <small>- Inter 14 Bold</small></a></div>
              <code>{renderToString(<a href={'/'} className='bold'>Display</a>)}</code>
              <hr />

              <div><a href={'/'} className='semibold hover'>Display <small>- Inter 14 Semi Bold</small></a></div>
              <code>{renderToString(<a href={'/'} className='semibold'>Display</a>)}</code>
              <hr />

              <div><a href={'/'} className='medium hover'>Display <small>- Inter 14 Medium</small></a></div>
              <code>{renderToString(<a href={'/'} className='medium'>Display</a>)}</code>
              <hr />

              <div><a href={'/'} className='hover'>Display <small>- Inter 14 Regular</small></a></div>
              <code className='mb-5'>{renderToString(<a href={'/'}>Display</a>)}</code>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Shadow">
            <Accordion.Header>Shadow</Accordion.Header>
            <Accordion.Body>
              <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                <div style={{ width: '100px', height: '100px' }} className='border rounded shadow1'>&nbsp;</div>
                <div className='text-center'>shadow1</div>
              </div>
              <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                <div style={{ width: '100px', height: '100px' }} className='border rounded shadow2'>&nbsp;</div>
                <div className='text-center'>shadow2</div>
              </div>
              <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                <div style={{ width: '100px', height: '100px' }} className='border rounded shadow3'>&nbsp;</div>
                <div className='text-center'>shadow3</div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Tags">
            <Accordion.Header>Tags</Accordion.Header>
            <Accordion.Body>

              <Row className='mb-5'>
                <Col xs={'auto'}><Badge bg={'custom-border-primary'}>Status</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-border-success'}>Status</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-border-warning'}>Status</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-border-danger'}>Status</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-border-info'}>Status</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-border-defalut'}>Status</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-border-light'}>Status</Badge></Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={'auto'}><Badge bg={'custom-border-primary btn-lg'}>Status Large</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-border-success btn-lg'}>Status Large</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-border-warning btn-lg'}>Status Large</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-border-danger btn-lg'}>Status Large</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-border-info btn-lg'}>Status Large</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-border-defalut btn-lg'}>Status Large</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-border-light btn-lg'}>Status Large</Badge></Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={'auto'}><Badge bg={'custom-primary'}>Status</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-success'}>Status</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-warning'}>Status</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-danger'}>Status</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-info'}>Status</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-defalut'}>Status</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-light'}>Status</Badge></Col>
              </Row>

              <Row>
                <Col xs={'auto'}><Badge bg={'custom-primary btn-lg'}>Status Large</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-success btn-lg'}>Status Large</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-warning btn-lg'}>Status Large</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-danger btn-lg'}>Status Large</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-info btn-lg'}>Status Large</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-defalut btn-lg'}>Status Large</Badge></Col>
                <Col xs={'auto'}><Badge bg={'custom-light btn-lg'}>Status Large</Badge></Col>
              </Row>

            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Tooltip">
            <Accordion.Header>Tooltip</Accordion.Header>
            <Accordion.Body>
              <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                <Tooltip title='This is a tooltip'>
                  <div style={{ width: '100px', height: '100px' }} className='border rounded shadow1'>&nbsp;</div>
                </Tooltip>
                <div className='text-center'>Light</div>
              </div>
              <div style={{ width: '100px', height: 'auto' }} className='mb-4 me-4 position-relative d-inline-block'>
                <Tooltip overlayClassName='dark' placement='right' title='This is a tooltip'>
                  <div style={{ width: '100px', height: '100px' }} className='border rounded shadow1'>&nbsp;</div>
                </Tooltip>
                <div className='text-center'>Dark</div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Popover">
            <Accordion.Header>Popover</Accordion.Header>
            <Accordion.Body>
              <div className='mb-20'>
                <Popover content={<div className='p-12'>Body</div>} title={<div className='p-12'>Body</div>} trigger="click">
                  <Button>Click me</Button>
                </Popover>
              </div>

              <div className='mb-20'>
                <div>Edit Title</div>
                <EditTitle
                  required={true}
                  value={''}
                  onUpdate={(val: any) => {
                    console.info(val);
                  }}
                />
              </div>

              <div>
                <div>Edit Time Zone</div>
                <EditTimeZone
                  required={true}
                  value={'Asia/Kuala_Lumpur'}
                  onUpdate={(val: any, opt: any) => {
                    console.info(val, opt);
                  }}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Navigation">
            <Accordion.Header>Navigation</Accordion.Header>
            <Accordion.Body>
              <div className='mb-5'>
                <Row className={'g-2 align-items-center'}>
                  <Col xs={'auto'}><StyledSmallerImage src={DefaultImage} roundedCircle /></Col>
                  <Col xs={'auto'}><small className={'fw-bold text-primary'}>WastePorter</small></Col>
                </Row>
              </div>

              <div className='mb-5'>
                <Row className={'g-2 align-items-center'}>
                  <Col xs={'auto'}>
                    <Dropdown>
                      <Dropdown.Toggle as={CustomToggle}>
                        <StyledBell>
                          <StyledBellIcon />
                          <StyledBellLabel><div className="text-wrapper">5</div></StyledBellLabel>
                        </StyledBell>
                      </Dropdown.Toggle>

                      {/* <Dropdown.Menu as={CustomMenu}>
                        <Dropdown.Item eventKey="1">Red</Dropdown.Item>
                      </Dropdown.Menu> */}
                    </Dropdown>
                  </Col>
                </Row>
              </div>

              <div className='mb-5'>
                <Dropdown>
                  <Dropdown.Toggle as={CustomToggle}>
                    <StyledImage src={DefaultImage} roundedCircle />
                  </Dropdown.Toggle>

                  <Dropdown.Menu as={CustomMenu}>
                    <Dropdown.Header>
                      <Stack direction={'horizontal'}>
                        <div className={'pe-3'}>
                          <StyledBiggerImage src={DefaultImage} roundedCircle />
                        </div>
                        <div>
                          <div><span className={'large fw-bold text-dark'}>Jaslin Wong</span></div>
                          <div><small className={'text-secondary'}>jaslin.wong@gmail.com</small></div>
                        </div>
                      </Stack>
                    </Dropdown.Header>

                    <li><hr className={'my-1'} /></li>

                    <Dropdown.Item>Settings</Dropdown.Item>
                    <Dropdown.Item>Profile</Dropdown.Item>
                    <Dropdown.Item>Sign out</Dropdown.Item>
                    <Dropdown.Item>Dropdown option</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="DateTime">
            <Accordion.Header>Date Time</Accordion.Header>
            <Accordion.Body>
              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <DatePicker
                    portal={true}
                    render={(value, openCalendar) => {
                      return <Button variant={'custom-none-primary'} onClick={openCalendar}><CalendarIcon /></Button>
                    }}
                    onChange={(value: DateObject) => {
                      console.info(`value = ${value}`);
                    }}
                  />
                </Col>
                <Col xs={12} md={3}>
                  <DatePicker
                    portal={true}
                    range={true}
                    render={(value, openCalendar) => {
                      return <Button variant={'custom-none-primary'} onClick={openCalendar}><CalendarIcon /></Button>
                    }}
                    // onChange={(value: DateObject) => {
                    //   console.info(`value = ${value}`);
                    // }}
                  />
                </Col>
                <Col xs={12} md={3}>
                  <DatePicker
                    portal={true}
                    multiple={true}
                    render={(value, openCalendar) => {
                      return <Button variant={'custom-none-primary'} onClick={openCalendar}><CalendarIcon /></Button>
                    }}
                    // onChange={(value: DateObject) => {
                    //   console.info(`value = ${value}`);
                    // }}
                  />
                </Col>
                <Col xs={12} md={3}>
                  <DatePicker 
                    portal={true}
                    disableDayPicker
                    format={timeFormat()}
                    render={(value, openCalendar) => {
                      return <Button variant={'custom-none-primary'} onClick={openCalendar}><ClockIcon /></Button>
                    }}
                    plugins={[
                      <TimePicker hideSeconds />
                    ]} 
                  />
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as = {InputMask}
                        mask={'99-99-9999'}
                        maskChar={null}
                        placeholder={dateFormat()}
                        value={selectedDate}
                        onChange={(e) => {
                          setSelectedDate(e.target.value);
                        }}
                        isInvalid={false}
                      />
                      <InputGroup.Text>
                        <DatePicker
                          portal={true}
                          onOpenPickNewDate={false}
                          shadow={false}
                          disabled={false}
                          calendarPosition={'bottom-right'} 
                          format={dateFormat()}
                          value={selectedDate}
                          onChange={(value: DateObject) => {
                            setSelectedDate(value.format(dateFormat()));
                          }}
                          render={(value, openCalendar) => {
                            return <Button variant={'custom-none-primary'} onClick={openCalendar}><CalendarIcon /></Button>
                          }}
                        />
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as = {InputMask}
                        mask={'99-99-9999'}
                        maskChar={null}
                        placeholder={dateFormat()}
                        value={selectedDate}
                        onChange={(e) => {
                          setSelectedDate(e.target.value);
                        }}
                        isInvalid={true}
                      />
                      <InputGroup.Text>
                        <DatePicker
                          portal={true}
                          onOpenPickNewDate={false}
                          shadow={false}
                          disabled={false}
                          calendarPosition={'bottom-right'} 
                          format={dateFormat()}
                          value={selectedDate}
                          onChange={(value: DateObject) => {
                            setSelectedDate(value.format(dateFormat()));
                          }}
                          render={(value, openCalendar) => {
                            return <Button variant={'custom-none-primary'} onClick={openCalendar}><CalendarIcon /></Button>
                          }}
                        />
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as = {InputMask}
                        mask={'99-99-9999'}
                        maskChar={null}
                        placeholder={dateFormat()}
                        value={selectedDate}
                        onChange={(e) => {
                          setSelectedDate(e.target.value);
                        }}
                        isValid={true}
                      />
                      <InputGroup.Text>
                        <DatePicker
                          portal={true}
                          onOpenPickNewDate={false}
                          shadow={false}
                          disabled={false}
                          calendarPosition={'bottom-right'} 
                          format={dateFormat()}
                          value={selectedDate}
                          onChange={(value: DateObject) => {
                            setSelectedDate(value.format(dateFormat()));
                          }}
                          render={(value, openCalendar) => {
                            return <Button variant={'custom-none-primary'} onClick={openCalendar}><CalendarIcon /></Button>
                          }}
                        />
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as = {InputMask}
                        mask={'99-99-9999'}
                        maskChar={null}
                        placeholder={dateFormat()}
                        value={selectedDate}
                        onChange={(e) => {
                          setSelectedDate(e.target.value);
                        }}
                        disabled={true}
                      />
                      <InputGroup.Text>
                        <DatePicker
                          portal={true}
                          onOpenPickNewDate={false}
                          shadow={false}
                          disabled={true}
                          calendarPosition={'bottom-right'} 
                          format={dateFormat()}
                          value={selectedDate}
                          onChange={(value: DateObject) => {
                            setSelectedDate(value.format(dateFormat()));
                          }}
                          render={(value, openCalendar) => {
                            return <Button variant={'custom-none-primary'} onClick={openCalendar} disabled={true}><CalendarIcon /></Button>
                          }}
                        />
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as = {InputMask}
                        mask={'99-99-9999 99:99'}
                        maskChar={null}
                        placeholder={dateTimeFormat()}
                        value={selectedDateTime}
                        onChange={(e) => {
                          setSelectedDateTime(e.target.value);
                        }}
                        isInvalid={false}
                      />
                      <InputGroup.Text>
                        <DatePicker
                          portal={true}
                          onOpenPickNewDate={false}
                          shadow={false}
                          disabled={false}
                          calendarPosition={'bottom-right'}
                          format={dateTimeFormat()}
                          value={selectedDateTime}
                          onChange={(value: DateObject) => {
                            setSelectedDateTime(value.format(dateTimeFormat()));
                          }}
                          render={(value, openCalendar) => {
                            return <Button variant={'custom-none-primary'} onClick={openCalendar}><CalendarIcon /></Button>
                          }}
                          plugins={[
                            <TimePicker hideSeconds position={'bottom'} />
                          ]}
                        />
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as = {InputMask}
                        mask={'99-99-9999 99:99'}
                        maskChar={null}
                        placeholder={dateTimeFormat()}
                        value={selectedDateTime}
                        onChange={(e) => {
                          setSelectedDateTime(e.target.value);
                        }}
                        isInvalid={true}
                      />
                      <InputGroup.Text>
                        <DatePicker
                          portal={true}
                          onOpenPickNewDate={false}
                          shadow={false}
                          disabled={false}
                          calendarPosition={'bottom-right'}
                          format={dateTimeFormat()}
                          value={selectedDateTime}
                          onChange={(value: DateObject) => {
                            setSelectedDateTime(value.format(dateTimeFormat()));
                          }}
                          render={(value, openCalendar) => {
                            return <Button variant={'custom-none-primary'} onClick={openCalendar}><CalendarIcon /></Button>
                          }}
                          plugins={[
                            <TimePicker hideSeconds position={'bottom'} />
                          ]}
                        />
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as = {InputMask}
                        mask={'99-99-9999 99:99'}
                        maskChar={null}
                        placeholder={dateTimeFormat()}
                        value={selectedDateTime}
                        onChange={(e) => {
                          setSelectedDateTime(e.target.value);
                        }}
                        isValid={true}
                      />
                      <InputGroup.Text>
                        <DatePicker
                          portal={true}
                          onOpenPickNewDate={false}
                          shadow={false}
                          disabled={false}
                          calendarPosition={'bottom-right'}
                          format={dateTimeFormat()}
                          value={selectedDateTime}
                          onChange={(value: DateObject) => {
                            setSelectedDateTime(value.format(dateTimeFormat()));
                          }}
                          render={(value, openCalendar) => {
                            return <Button variant={'custom-none-primary'} onClick={openCalendar}><CalendarIcon /></Button>
                          }}
                          plugins={[
                            <TimePicker hideSeconds position={'bottom'} />
                          ]}
                        />
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as = {InputMask}
                        mask={'99-99-9999 99:99'}
                        maskChar={null}
                        placeholder={dateTimeFormat()}
                        value={selectedDateTime}
                        onChange={(e) => {
                          setSelectedDateTime(e.target.value);
                        }}
                        disabled={true}
                      />
                      <InputGroup.Text>
                        <DatePicker
                          portal={true}
                          onOpenPickNewDate={false}
                          shadow={false}
                          disabled={true}
                          calendarPosition={'bottom-right'}
                          format={dateTimeFormat()}
                          value={selectedDateTime}
                          onChange={(value: DateObject) => {
                            setSelectedDateTime(value.format(dateTimeFormat()));
                          }}
                          render={(value, openCalendar) => {
                            return <Button variant={'custom-none-primary'} onClick={openCalendar} disabled={true}><CalendarIcon /></Button>
                          }}
                          plugins={[
                            <TimePicker hideSeconds position={'bottom'} />
                          ]}
                        />
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as = {InputMask}
                        mask={'99:99'}
                        maskChar={null}
                        placeholder={timeFormat()}
                        value={selectedTime}
                        onChange={(e) => {
                          setSelectedTime(e.target.value);
                        }}
                        isInvalid={false}
                      />
                      <InputGroup.Text>
                        <DatePicker
                          portal={true}
                          onOpenPickNewDate={false}
                          shadow={false}
                          disabled={false}
                          calendarPosition={'bottom-right'}
                          format={timeFormat()}
                          value={getDateObjectTime(selectedTime)}
                          onChange={(value: DateObject) => {
                            setSelectedTime(value.format(timeFormat()));
                          }}
                          disableDayPicker
                          render={(value, openCalendar) => {
                            return <Button variant={'custom-none-primary'} onClick={openCalendar}><ClockIcon /></Button>
                          }}
                          plugins={[
                            <TimePicker hideSeconds />
                          ]}
                        />
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as = {InputMask}
                        mask={'99:99'}
                        maskChar={null}
                        placeholder={timeFormat()}
                        value={selectedTime}
                        onChange={(e) => {
                          setSelectedTime(e.target.value);
                        }}
                        isInvalid={true}
                      />
                      <InputGroup.Text>
                        <DatePicker
                          portal={true}
                          onOpenPickNewDate={false}
                          shadow={false}
                          disabled={false}
                          calendarPosition={'bottom-right'}
                          format={timeFormat()}
                          value={getDateObjectTime(selectedTime)}
                          onChange={(value: DateObject) => {
                            setSelectedTime(value.format(timeFormat()));
                          }}
                          disableDayPicker
                          render={(value, openCalendar) => {
                            return <Button variant={'custom-none-primary'} onClick={openCalendar}><ClockIcon /></Button>
                          }}
                          plugins={[
                            <TimePicker hideSeconds />
                          ]}
                        />
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as = {InputMask}
                        mask={'99:99'}
                        maskChar={null}
                        placeholder={timeFormat()}
                        value={selectedTime}
                        onChange={(e) => {
                          setSelectedTime(e.target.value);
                        }}
                        isValid={true}
                      />
                      <InputGroup.Text>
                        <DatePicker
                          portal={true}
                          onOpenPickNewDate={false}
                          shadow={false}
                          disabled={false}
                          calendarPosition={'bottom-right'}
                          format={timeFormat()}
                          value={getDateObjectTime(selectedTime)}
                          onChange={(value: DateObject) => {
                            setSelectedTime(value.format(timeFormat()));
                          }}
                          disableDayPicker
                          render={(value, openCalendar) => {
                            return <Button variant={'custom-none-primary'} onClick={openCalendar}><ClockIcon /></Button>
                          }}
                          plugins={[
                            <TimePicker hideSeconds />
                          ]}
                        />
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as = {InputMask}
                        mask={'99:99'}
                        maskChar={null}
                        placeholder={timeFormat()}
                        value={selectedTime}
                        onChange={(e) => {
                          setSelectedTime(e.target.value);
                        }}
                        disabled={true}
                      />
                      <InputGroup.Text>
                        <DatePicker
                          portal={true}
                          onOpenPickNewDate={false}
                          shadow={false}
                          disabled={true}
                          calendarPosition={'bottom-right'}
                          format={timeFormat()}
                          value={getDateObjectTime(selectedTime)}
                          onChange={(value: DateObject) => {
                            setSelectedTime(value.format(timeFormat()));
                          }}
                          disableDayPicker
                          render={(value, openCalendar) => {
                            return <Button variant={'custom-none-primary'} onClick={openCalendar} disabled={true}><ClockIcon /></Button>
                          }}
                          plugins={[
                            <TimePicker hideSeconds />
                          ]}
                        />
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="DateRange">
            <Accordion.Header>Date Range</Accordion.Header>
            <Accordion.Body>
              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <RangePicker
                    icon={<CalendarIcon />}
                    ranges={ranges}
                    onChange={(item: any) => {
                      setRanges([item.selection]);
                    }}
                    showSelectionPreview={true}
                    moveRangeOnFirstSelection={false}
                    showDateDisplay={false}
                    months={2}
                    direction="horizontal"
                    staticRanges={getDateRanges([])}
                    renderStaticRangeLabel={(props: any) => {
                      return <>{props.label}</>
                    }}
                  />
                </Col>
                <Col xs={12} md={3}>
                  <RangePicker
                    icon={<CalendarIcon />}
                    placement={'bottom'}
                    ranges={ranges}
                    onChange={(item: any) => {
                      setRanges([item.selection]);
                    }}
                    showSelectionPreview={true}
                    moveRangeOnFirstSelection={false}
                    showDateDisplay={false}
                    months={1}
                    direction="horizontal"
                  />
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Buttons">
            <Accordion.Header>Buttons</Accordion.Header>
            <Accordion.Body>
              <Button variant={'custom-primary'} size={'sm'}>Primary sm</Button>{' '}
              <Button variant={'custom-primary'}>Primary</Button>{' '}
              <Button variant={'custom-primary'} size={'lg'}>Primary lg</Button>{' '}
              <Button variant={'custom-primary'} disabled>Primary</Button>{' '}
              <div className={'my-3'}></div>
              <Button variant={'custom-secondary'} size={'sm'}>Secondary sm</Button>{' '}
              <Button variant={'custom-secondary'}>Secondary</Button>{' '}
              <Button variant={'custom-secondary'} size={'lg'}>Secondary lg</Button>{' '}
              <Button variant={'custom-secondary'} disabled>Secondary</Button>{' '}
              <div className={'my-3'}></div>
              <Button variant={'custom-outlined'} size={'sm'}>Outlined sm</Button>{' '}
              <Button variant={'custom-outlined'}>Outlined</Button>{' '}
              <Button variant={'custom-outlined'} size={'lg'}>Outlined lg</Button>{' '}
              <Button variant={'custom-outlined'} disabled>Outlined</Button>{' '}
              <div className={'my-3'}></div>
              <Button variant={'custom-label-outlined'} size={'sm'}>Label sm</Button>{' '}
              <Button variant={'custom-label-outlined'}>Label</Button>{' '}
              <Button variant={'custom-label-outlined'} size={'lg'}>Label lg</Button>{' '}
              <Button variant={'custom-label-outlined'} disabled>Label</Button>{' '}
              <div className={'my-3'}></div>
              <Button variant={'custom-text'} size={'sm'}>Text sm</Button>{' '}
              <Button variant={'custom-text'}>Text</Button>{' '}
              <Button variant={'custom-text'} size={'lg'}>Text lg</Button>{' '}
              <Button variant={'custom-text'} disabled>Text</Button>{' '}
              <div className={'my-3'}></div>
              <Button variant={'custom-text'} size={'sm'}><PlusIcon /> Add new category</Button>{' '}
              <Button variant={'custom-text'}><PlusIcon /> Add new category</Button>{' '}
              <Button variant={'custom-text'} size={'lg'}><PlusIcon /> Add new category</Button>{' '}
              <Button variant={'custom-text'} disabled><PlusIcon /> Add new category</Button>{' '}
              <div className={'my-3'}></div>
              <Button variant={'custom-text-primary'} size={'sm'}><CopyIcon /> Clone</Button>{' '}
              <Button variant={'custom-text-primary'}><CopyIcon /> Clone</Button>{' '}
              <Button variant={'custom-text-primary'} size={'lg'}><CopyIcon /> Clone</Button>{' '}
              <Button variant={'custom-text-primary'} disabled><CopyIcon /> Clone</Button>{' '}
              <div className={'my-3'}></div>
              <Button variant={"custom-danger"} size={'sm'}>Danger sm</Button>{' '}
              <Button variant={"custom-danger"}>Danger</Button>{' '}
              <Button variant={"custom-danger"} size={'lg'}>Danger lg</Button>{' '}
              <Button variant={"custom-danger"} disabled>Danger</Button>{' '}
              <div className={'my-3'}></div>
              <Button variant={"custom-success"} size={'sm'}>Success sm</Button>{' '}
              <Button variant={"custom-success"}>Success</Button>{' '}
              <Button variant={"custom-success"} size={'lg'}>Success lg</Button>{' '}
              <Button variant={"custom-success"} disabled>Success</Button>{' '}
              <div className={'my-3'}></div>
              <Button variant={'custom-secondary-danger'} size={'sm'}>Secondary Danger sm</Button>{' '}
              <Button variant={'custom-secondary-danger'}>Secondary Danger</Button>{' '}
              <Button variant={'custom-secondary-danger'} size={'lg'}>Secondary Danger lg</Button>{' '}
              <Button variant={'custom-secondary-danger'} disabled>Secondary Danger</Button>{' '}
              <div className={'my-3'}></div>
              <Button variant={'custom-none-primary'} size={'sm'}><EditIcon /></Button>{' '}
              <Button variant={'custom-none-primary'}><EditIcon /></Button>{' '}
              <Button variant={'custom-none-primary'} size={'lg'}><EditIcon /></Button>{' '}
              <Button variant={'custom-none-primary'} disabled><EditIcon /></Button>{' '}
              <div className={'my-3'}></div>
              <Button variant={'custom-none-secondary'} size={'sm'}><EditIcon /></Button>{' '}
              <Button variant={'custom-none-secondary'}><EditIcon /></Button>{' '}
              <Button variant={'custom-none-secondary'} size={'lg'}><EditIcon /></Button>{' '}
              <Button variant={'custom-none-secondary'} disabled><EditIcon /></Button>{' '}
              <div className={'my-3'}></div>
              <Button variant={'custom-icon-primary'} size={'sm'}><EditIcon /></Button>{' '}
              <Button variant={'custom-icon-primary'}><EditIcon /></Button>{' '}
              <Button variant={'custom-icon-primary'} size={'lg'}><EditIcon /></Button>{' '}
              <Button variant={'custom-icon-primary'} disabled><EditIcon /></Button>{' '}
              <div className={'my-3'}></div>
              <Button variant={'custom-icon-danger'} size={'sm'}><EditIcon /></Button>{' '}
              <Button variant={'custom-icon-danger'}><EditIcon /></Button>{' '}
              <Button variant={'custom-icon-danger'} size={'lg'}><EditIcon /></Button>{' '}
              <Button variant={'custom-icon-danger'} disabled><EditIcon /></Button>{' '}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Stepper">
            <Accordion.Header>Stepper</Accordion.Header>
            <Accordion.Body>

              <Row className='mb-5'>
                <Col xs={12} md={1}>
                  <Form.Group className='plus-minus-button'>
                    <InputGroup>
                      <InputGroup.Text
                        onClick={() => {
                          const minNumb = 1;
                          let numb = isNumeric(valuePlusMinus) ? parseInt(valuePlusMinus) : 1;

                          if(numb > minNumb){
                            setValuePlusMinus((numb-1).toString())
                          }
                        }}
                      >
                        <MinusIcon />
                      </InputGroup.Text>
                      <Form.Control
                        className='custom'
                        as={CurrencyInput}
                        allowDecimals={false}
                        allowNegativeValue={false}
                        decimalsLimit={0}
                        maxLength={2}

                        disabled={false}
                        autoComplete='off'
                        placeholder={''}
                        value={valuePlusMinus}
                        onValueChange={(value: any) => {
                          setValuePlusMinus(value)
                        }}
                        onBlur={async () => {
                          let numb = isNumeric(valuePlusMinus) ? parseInt(valuePlusMinus) : 0;

                          if(numb < 1){
                            await setValuePlusMinus(1);
                          } else if(numb > 99){
                            await setValuePlusMinus(99);
                          }
                        }}
                        isInvalid={false}
                      />
                      <InputGroup.Text
                        onClick={() => {
                          const maxNumb = 99;
                          let numb = isNumeric(valuePlusMinus) ? parseInt(valuePlusMinus) : 1;

                          if(numb < maxNumb){
                            setValuePlusMinus((numb+1).toString())
                          }
                        }}
                      >
                        <PlusIcon />
                      </InputGroup.Text>
                    </InputGroup>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className='mb-5'>
                <Col xs={12} md={1}>
                  <Form.Group className='plus-minus-button-start'>
                    <InputGroup>
                      <Form.Control
                        className='custom'
                        as={CurrencyInput}
                        allowDecimals={false}
                        allowNegativeValue={false}
                        decimalsLimit={0}
                        maxLength={2}

                        disabled={false}
                        autoComplete='off'
                        placeholder={''}
                        value={valuePlusMinus}
                        onValueChange={(value: any) => {
                          setValuePlusMinus(value)
                        }}
                        onBlur={async () => {
                          let numb = isNumeric(valuePlusMinus) ? parseInt(valuePlusMinus) : 0;

                          if(numb < 1){
                            await setValuePlusMinus(1);
                          } else if(numb > 99){
                            await setValuePlusMinus(99);
                          }
                        }}
                        isInvalid={false}
                      />
                      <InputGroup.Text>
                        <span
                          onClick={() => {
                            const minNumb = 1;
                            let numb = isNumeric(valuePlusMinus) ? parseInt(valuePlusMinus) : 1;

                            if(numb > minNumb){
                              setValuePlusMinus((numb-1).toString())
                            }
                          }}
                        >
                          <MinusIcon />
                        </span>
                        <span
                          onClick={() => {
                            const maxNumb = 99;
                            let numb = isNumeric(valuePlusMinus) ? parseInt(valuePlusMinus) : 1;

                            if(numb < maxNumb){
                              setValuePlusMinus((numb+1).toString())
                            }
                          }}
                        >
                          <PlusIcon />
                        </span>
                      </InputGroup.Text>
                    </InputGroup>
                  </Form.Group>
                </Col>
              </Row>

            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="ColorPicker">
            <Accordion.Header>Color Picker</Accordion.Header>
            <Accordion.Body>
              <div className='mb-20'>
                <ColorPicker
                  value={selectedColor}
                  onChange={(val: any) => {
                    console.info(val);
                    setSelectedColor(val)
                  }}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Inputs">
            <Accordion.Header>Inputs</Accordion.Header>
            <Accordion.Body>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Control
                      type={'text'}
                      autoComplete='off'
                      placeholder={'Input placeholder'}
                      isInvalid={false}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Control
                      type={'text'}
                      autoComplete='off'
                      placeholder={'Input placeholder'}
                      isInvalid={true}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Control
                      type={'text'}
                      autoComplete='off'
                      placeholder={'Input placeholder'}
                      isValid={true}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Control
                      type={'text'}
                      autoComplete='off'
                      placeholder={'Input placeholder'}
                      disabled={true}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>Input label</Form.Label>
                    <Form.Control
                      type={'text'}
                      autoComplete='off'
                      placeholder={'Input placeholder'}
                      isInvalid={false}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>Input label</Form.Label>
                    <Form.Control
                      type={'text'}
                      autoComplete='off'
                      placeholder={'Input placeholder'}
                      isInvalid={true}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>Input label</Form.Label>
                    <Form.Control
                      type={'text'}
                      autoComplete='off'
                      placeholder={'Input placeholder'}
                      isValid={true}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>Input label</Form.Label>
                    <Form.Control
                      type={'text'}
                      autoComplete='off'
                      placeholder={'Input placeholder'}
                      disabled={true}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      type={'text'}
                      autoComplete='off'
                      placeholder={'Input placeholder'}
                      isInvalid={false}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      type={'text'}
                      autoComplete='off'
                      placeholder={'Input placeholder'}
                      isInvalid={true}
                    />
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      type={'text'}
                      autoComplete='off'
                      placeholder={'Input placeholder'}
                      isValid={true}
                    />
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      type={'text'}
                      autoComplete='off'
                      placeholder={'Input placeholder'}
                      disabled={true}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={'text'}
                        autoComplete='off'
                        placeholder={'Input placeholder'}
                        isInvalid={false}
                      />
                      <InputGroup.Text>
                        <MapPinIcon />
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={'text'}
                        autoComplete='off'
                        placeholder={'Input placeholder'}
                        isInvalid={true}
                      />
                      <InputGroup.Text>
                        <MapPinIcon />
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={'text'}
                        autoComplete='off'
                        placeholder={'Input placeholder'}
                        isValid={true}
                      />
                      <InputGroup.Text>
                        <MapPinIcon />
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={'text'}
                        autoComplete='off'
                        placeholder={'Input placeholder'}
                        disabled={true}
                      />
                      <InputGroup.Text>
                        <MapPinIcon />
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as={CurrencyInput}
                        allowDecimals={true}
                        allowNegativeValue={false}
                        decimalsLimit={2}

                        autoComplete='off'
                        placeholder={'Input placeholder'}
                        // value={0}
                        defaultValue={'123456.123'}
                        onValueChange={(value: any) => {
                          console.info('⚡ | value:', value);
                        }}
                        isInvalid={false}
                      />
                      <InputGroup.Text className={'border-start'}>/ km</InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as={CurrencyInput}
                        allowDecimals={true}
                        allowNegativeValue={false}
                        decimalsLimit={2}

                        autoComplete='off'
                        placeholder={'Input placeholder'}
                        // value={0}
                        defaultValue={'123456.123'}
                        onValueChange={(value: any) => {
                          console.info('⚡ | value:', value);
                        }}
                        isInvalid={true}
                      />
                      <InputGroup.Text className={'border-start'}>/ km</InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as={CurrencyInput}
                        allowDecimals={true}
                        allowNegativeValue={false}
                        decimalsLimit={2}

                        autoComplete='off'
                        placeholder={'Input placeholder'}
                        // value={0}
                        defaultValue={'123456.123'}
                        onValueChange={(value: any) => {
                          console.info('⚡ | value:', value);
                        }}
                        isValid={true}
                      />
                      <InputGroup.Text className={'border-start'}>/ km</InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as={CurrencyInput}
                        allowDecimals={true}
                        allowNegativeValue={false}
                        decimalsLimit={2}

                        autoComplete='off'
                        placeholder={'Input placeholder'}
                        // value={0}
                        defaultValue={'123456.123'}
                        onValueChange={(value: any) => {
                          console.info('⚡ | value:', value);
                        }}
                        isInvalid={false}
                        disabled={true}
                      />
                      <InputGroup.Text className={'border-start'}>/ km</InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={'text'}
                        autoComplete='off'
                        placeholder={'Input placeholder'}
                        isInvalid={false}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><EyeIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={'text'}
                        autoComplete='off'
                        placeholder={'Input placeholder'}
                        isInvalid={true}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><EyeIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={'text'}
                        autoComplete='off'
                        placeholder={'Input placeholder'}
                        isValid={true}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><EyeIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={'text'}
                        autoComplete='off'
                        placeholder={'Input placeholder'}
                        disabled={true}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'} disabled={true}><EyeIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={'text'}
                        autoComplete='off'
                        placeholder={'Input placeholder'}
                        isInvalid={false}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={'text'}
                        autoComplete='off'
                        placeholder={'Input placeholder'}
                        isInvalid={true}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={'text'}
                        autoComplete='off'
                        placeholder={'Input placeholder'}
                        isValid={true}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        type={'text'}
                        autoComplete='off'
                        placeholder={'Input placeholder'}
                        disabled={true}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'} disabled={true}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text className={'border-end'}>
                        <ColorPicker
                          value={selectedColor}
                          onChange={(val: any) => {
                            console.info(val);
                            setSelectedColor(val)
                          }}
                        />
                      </InputGroup.Text>
                      <Form.Control
                        type={'text'}
                        autoComplete='off'
                        placeholder={'Input placeholder'}
                        isInvalid={false}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text className={'border-end'}>
                        <ColorPicker
                          value={selectedColor}
                          onChange={(val: any) => {
                            console.info(val);
                            setSelectedColor(val)
                          }}
                        />
                      </InputGroup.Text>
                      <Form.Control
                        type={'text'}
                        autoComplete='off'
                        placeholder={'Input placeholder'}
                        isInvalid={true}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text className={'border-end'}>
                        <ColorPicker
                          value={selectedColor}
                          onChange={(val: any) => {
                            console.info(val);
                            setSelectedColor(val)
                          }}
                        />
                      </InputGroup.Text>
                      <Form.Control
                        type={'text'}
                        autoComplete='off'
                        placeholder={'Input placeholder'}
                        isValid={true}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text className={'border-end'}>
                        <ColorPicker
                          value={selectedColor}
                          onChange={(val: any) => {
                            console.info(val);
                            setSelectedColor(val)
                          }}
                        />
                      </InputGroup.Text>
                      <Form.Control
                        type={'text'}
                        autoComplete='off'
                        placeholder={'Input placeholder'}
                        disabled={true}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'} disabled={true}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Textarea">
            <Accordion.Header>Textarea</Accordion.Header>
            <Accordion.Body>
              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>Textarea label</Form.Label>
                    <Form.Control
                      as="textarea"
                      className='textarea-noresize'
                      rows={3}
                      placeholder={'Input placeholder'}
                      isInvalid={false}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>Textarea label</Form.Label>
                    <Form.Control
                      as="textarea"
                      name='noresize'
                      rows={3}
                      placeholder={'Input placeholder'}
                      isInvalid={true}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>Textarea label</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder={'Input placeholder'}
                      isValid={true}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>Textarea label</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder={'Input placeholder'}
                      disabled={true}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Rich Text Editor">
            <Accordion.Header>Rich Text Editor</Accordion.Header>
            <Accordion.Body>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>Rich Text Editor label</Form.Label>
                    <Form.Control
                      as = {RTextEditor}
                      placeholder={'Input placeholder'}
                      editorState={messageEditorState}
                      onChangeValue={(plainText: any, html: any, editorState: any) => {
                        setMessagePlainText(plainText);
                        setMessageHTML(html);
                        setMessageEditorState(editorState);
                      }}
                      isInvalid={false}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>Rich Text Editor label</Form.Label>
                    <Form.Control
                      as = {RTextEditor}
                      placeholder={'Input placeholder'}
                      editorState={createEditorState('')}
                      onChangeValue={(plainText: any, html: any, editorState: any) => {

                      }}
                      isInvalid={true}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>Rich Text Editor label</Form.Label>
                    <Form.Control
                      as = {RTextEditor}
                      placeholder={'Input placeholder'}
                      editorState={createEditorState('')}
                      onChangeValue={(plainText: any, html: any, editorState: any) => {
                        
                      }}
                      isValid={true}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>Rich Text Editor label</Form.Label>
                    <Form.Control
                      as = {RTextEditor}
                      placeholder={'Input placeholder'}
                      editorState={messageEditorState}
                      onChangeValue={(plainText: any, html: any, editorState: any) => {
                        setMessagePlainText(plainText);
                        setMessageHTML(html);
                        setMessageEditorState(editorState);
                      }}
                      disabled={true}
                    />
                  </Form.Group>
                </Col>
              </Row>
              
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Select">
            <Accordion.Header>Select</Accordion.Header>
            <Accordion.Body>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value="lucy"
                      // mode="multiple"
                      placeholder={'Select'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={true}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value="lucy"
                      // mode="multiple"
                      placeholder={'Select'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={true}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                      isInvalid={true}
                    />
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value="lucy"
                      // mode="multiple"
                      placeholder={'Select'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={true}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                      isValid={true}
                    />
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value="lucy"
                      // mode="multiple"
                      placeholder={'Select'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={true}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                      disabled={true}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value="lucy"
                      // mode="multiple"
                      placeholder={'Select'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      optionRender={(option: any, ref: any) => {
                        return <Row className={'g-2'}>
                          <Col xs={true}>{option.label}</Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-primary'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Edit2Icon />
                            </Button>
                          </Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-danger'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Trash2Icon />
                            </Button>
                          </Col>
                        </Row>
                      }}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value="lucy"
                      // mode="multiple"
                      placeholder={'Select'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      optionRender={(option: any, ref: any) => {
                        return <Row className={'g-2'}>
                          <Col xs={true}>{option.label}</Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-primary'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Edit2Icon />
                            </Button>
                          </Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-danger'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Trash2Icon />
                            </Button>
                          </Col>
                        </Row>
                      }}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                      isInvalid={true}
                    />
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value="lucy"
                      // mode="multiple"
                      placeholder={'Select'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      optionRender={(option: any, ref: any) => {
                        return <Row className={'g-2'}>
                          <Col xs={true}>{option.label}</Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-primary'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Edit2Icon />
                            </Button>
                          </Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-danger'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Trash2Icon />
                            </Button>
                          </Col>
                        </Row>
                      }}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                      isValid={true}
                    />
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value="lucy"
                      // mode="multiple"
                      placeholder={'Select'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      optionRender={(option: any, ref: any) => {
                        return <Row className={'g-2'}>
                          <Col xs={true}>{option.label}</Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-primary'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Edit2Icon />
                            </Button>
                          </Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-danger'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Trash2Icon />
                            </Button>
                          </Col>
                        </Row>
                      }}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                      disabled={true}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value="lucy"
                      mode="multiple"
                      placeholder={'Select'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={true}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value="lucy"
                      mode="multiple"
                      placeholder={'Select'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={true}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                      isInvalid={true}
                    />
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value="lucy"
                      mode="multiple"
                      placeholder={'Select'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={true}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                      isValid={true}
                    />
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value="lucy"
                      mode="multiple"
                      placeholder={'Select'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={true}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                      disabled={true}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value="lucy"
                      mode="multiple"
                      placeholder={'Select'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      optionRender={(option: any, ref: any) => {
                        return <Row className={'g-2'}>
                          <Col xs={true}>{option.label}</Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-primary'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Edit2Icon />
                            </Button>
                          </Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-danger'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Trash2Icon />
                            </Button>
                          </Col>
                        </Row>
                      }}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value="lucy"
                      mode="multiple"
                      placeholder={'Select'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      optionRender={(option: any, ref: any) => {
                        return <Row className={'g-2'}>
                          <Col xs={true}>{option.label}</Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-primary'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Edit2Icon />
                            </Button>
                          </Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-danger'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Trash2Icon />
                            </Button>
                          </Col>
                        </Row>
                      }}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                      isInvalid={true}
                    />
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value="lucy"
                      mode="multiple"
                      placeholder={'Select'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      optionRender={(option: any, ref: any) => {
                        return <Row className={'g-2'}>
                          <Col xs={true}>{option.label}</Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-primary'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Edit2Icon />
                            </Button>
                          </Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-danger'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Trash2Icon />
                            </Button>
                          </Col>
                        </Row>
                      }}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                      isValid={true}
                    />
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value="lucy"
                      mode="multiple"
                      placeholder={'Select'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      optionRender={(option: any, ref: any) => {
                        return <Row className={'g-2'}>
                          <Col xs={true}>{option.label}</Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-primary'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Edit2Icon />
                            </Button>
                          </Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-danger'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Trash2Icon />
                            </Button>
                          </Col>
                        </Row>
                      }}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                      disabled={true}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value="lucy"
                      // mode="multiple"
                      placeholder={'Select'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={true}
                      loading={true}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value="lucy"
                      // mode="multiple"
                      placeholder={'Select'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={true}
                      loading={true}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                      isInvalid={true}
                    />
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value="lucy"
                      // mode="multiple"
                      placeholder={'Select'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={true}
                      loading={true}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                      isValid={true}
                    />
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value="lucy"
                      // mode="multiple"
                      placeholder={'Select'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={true}
                      loading={true}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                      disabled={true}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={SmartSelect}
                      value={selectValueId}
                      // mode="multiple"
                      placeholder={'Select'}
                      addText={'Add new group'}
                      apiPath={'vehicle-group'}
                      fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                      selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                      hasOptionRender={true}
                      hasFooterRender={true}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      onChangeValue={async (value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option, ref);
                        if(option){
                          setSelectValueId(value);
                          setSelectValueName(option.label);
                        } else {
                          setSelectValueId(null);
                          setSelectValueName('');
                        }
                      }}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={SmartSelect}
                      value={selectValueId}
                      // mode="multiple"
                      placeholder={'Select'}
                      addText={'Add new group'}
                      apiPath={'vehicle-group'}
                      fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                      selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                      hasOptionRender={true}
                      hasFooterRender={true}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      onChangeValue={async (value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option, ref);
                        if(option){
                          setSelectValueId(value);
                          setSelectValueName(option.label);
                        } else {
                          setSelectValueId(null);
                          setSelectValueName('');
                        }
                      }}
                      isInvalid={true}
                    />
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={SmartSelect}
                      value={selectValueId}
                      // mode="multiple"
                      placeholder={'Select'}
                      addText={'Add new group'}
                      apiPath={'vehicle-group'}
                      fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                      selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                      hasOptionRender={true}
                      hasFooterRender={true}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      onChangeValue={async (value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option, ref);
                        if(option){
                          setSelectValueId(value);
                          setSelectValueName(option.label);
                        } else {
                          setSelectValueId(null);
                          setSelectValueName('');
                        }
                      }}
                      isValid={true}
                    />
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={SmartSelect}
                      value={selectValueId}
                      // mode="multiple"
                      placeholder={'Select'}
                      addText={'Add new group'}
                      apiPath={'vehicle-group'}
                      fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                      selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                      hasOptionRender={true}
                      hasFooterRender={true}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      onChangeValue={async (value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option, ref);
                        if(option){
                          setSelectValueId(value);
                          setSelectValueName(option.label);
                        } else {
                          setSelectValueId(null);
                          setSelectValueName('');
                        }
                      }}
                      disabled={true}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as={SmartSelect}
                        value={selectValueId}
                        // mode="multiple"
                        placeholder={'Select'}
                        addText={'Add new group'}
                        apiPath={'vehicle-group'}
                        fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                        selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                        hasOptionRender={true}
                        hasFooterRender={true}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={false}
                        onChangeValue={async (value: any, option: any, ref: any) => {
                          console.info(`selected ${value}`, option, ref);
                          if(option){
                            setSelectValueId(value);
                            setSelectValueName(option.label);
                          } else {
                            setSelectValueId(null);
                            setSelectValueName('');
                          }
                        }}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as={SmartSelect}
                        value={selectValueId}
                        // mode="multiple"
                        placeholder={'Select'}
                        addText={'Add new group'}
                        apiPath={'vehicle-group'}
                        fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                        selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                        hasOptionRender={true}
                        hasFooterRender={true}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={false}
                        onChangeValue={async (value: any, option: any, ref: any) => {
                          console.info(`selected ${value}`, option, ref);
                          if(option){
                            setSelectValueId(value);
                            setSelectValueName(option.label);
                          } else {
                            setSelectValueId(null);
                            setSelectValueName('');
                          }
                        }}
                        isInvalid={true}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                      <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as={SmartSelect}
                        value={selectValueId}
                        // mode="multiple"
                        placeholder={'Select'}
                        addText={'Add new group'}
                        apiPath={'vehicle-group'}
                        fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                        selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                        hasOptionRender={true}
                        hasFooterRender={true}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={false}
                        onChangeValue={async (value: any, option: any, ref: any) => {
                          console.info(`selected ${value}`, option, ref);
                          if(option){
                            setSelectValueId(value);
                            setSelectValueName(option.label);
                          } else {
                            setSelectValueId(null);
                            setSelectValueName('');
                          }
                        }}
                        isValid={true}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                      <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as={SmartSelect}
                        value={selectValueId}
                        // mode="multiple"
                        placeholder={'Select'}
                        addText={'Add new group'}
                        apiPath={'vehicle-group'}
                        fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                        selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                        hasOptionRender={true}
                        hasFooterRender={true}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={false}
                        onChangeValue={async (value: any, option: any, ref: any) => {
                          console.info(`selected ${value}`, option, ref);
                          if(option){
                            setSelectValueId(value);
                            setSelectValueName(option.label);
                          } else {
                            setSelectValueId(null);
                            setSelectValueName('');
                          }
                        }}
                        disabled={true}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'} disabled={true}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text className={'border-end'}>
                        <ColorPicker
                          value={selectedColor}
                          onChange={(val: any) => {
                            console.info(val);
                            setSelectedColor(val)
                          }}
                        />
                      </InputGroup.Text>
                      <Form.Control
                        as={SmartSelect}
                        value={selectValueId}
                        // mode="multiple"
                        placeholder={'Select'}
                        addText={'Add new group'}
                        apiPath={'vehicle-group'}
                        fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                        selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                        hasOptionRender={true}
                        hasFooterRender={true}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={false}
                        onChangeValue={async (value: any, option: any, ref: any) => {
                          console.info(`selected ${value}`, option, ref);
                          if(option){
                            setSelectValueId(value);
                            setSelectValueName(option.label);
                          } else {
                            setSelectValueId(null);
                            setSelectValueName('');
                          }
                        }}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text className={'border-end'}>
                        <ColorPicker
                          value={selectedColor}
                          onChange={(val: any) => {
                            console.info(val);
                            setSelectedColor(val)
                          }}
                        />
                      </InputGroup.Text>
                      <Form.Control
                        as={SmartSelect}
                        value={selectValueId}
                        // mode="multiple"
                        placeholder={'Select'}
                        addText={'Add new group'}
                        apiPath={'vehicle-group'}
                        fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                        selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                        hasOptionRender={true}
                        hasFooterRender={true}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={false}
                        onChangeValue={async (value: any, option: any, ref: any) => {
                          console.info(`selected ${value}`, option, ref);
                          if(option){
                            setSelectValueId(value);
                            setSelectValueName(option.label);
                          } else {
                            setSelectValueId(null);
                            setSelectValueName('');
                          }
                        }}
                        isInvalid={true}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                      <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text className={'border-end'}>
                        <ColorPicker
                          value={selectedColor}
                          onChange={(val: any) => {
                            console.info(val);
                            setSelectedColor(val)
                          }}
                        />
                      </InputGroup.Text>
                      <Form.Control
                        as={SmartSelect}
                        value={selectValueId}
                        // mode="multiple"
                        placeholder={'Select'}
                        addText={'Add new group'}
                        apiPath={'vehicle-group'}
                        fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                        selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                        hasOptionRender={true}
                        hasFooterRender={true}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={false}
                        onChangeValue={async (value: any, option: any, ref: any) => {
                          console.info(`selected ${value}`, option, ref);
                          if(option){
                            setSelectValueId(value);
                            setSelectValueName(option.label);
                          } else {
                            setSelectValueId(null);
                            setSelectValueName('');
                          }
                        }}
                        isValid={true}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                      <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text className={'border-end'}>
                        <ColorPicker
                          disabled={true}
                          value={selectedColor}
                          onChange={(val: any) => {
                            console.info(val);
                            setSelectedColor(val)
                          }}
                        />
                      </InputGroup.Text>
                      <Form.Control
                        as={SmartSelect}
                        value={selectValueId}
                        // mode="multiple"
                        placeholder={'Select'}
                        addText={'Add new group'}
                        apiPath={'vehicle-group'}
                        fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                        selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                        hasOptionRender={true}
                        hasFooterRender={true}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={false}
                        onChangeValue={async (value: any, option: any, ref: any) => {
                          console.info(`selected ${value}`, option, ref);
                          if(option){
                            setSelectValueId(value);
                            setSelectValueName(option.label);
                          } else {
                            setSelectValueId(null);
                            setSelectValueName('');
                          }
                        }}
                        disabled={true}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'} disabled={true}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={SmartSelect}
                      value={selectDriverValueId}
                      mode="multiple"
                      maxTagCount={'responsive'}
                      placeholder={'Select'}
                      addText={'Add new driver'}
                      apiPath={'driver'}
                      fieldNames={{ value: 'driverId', label: 'driverName' }}
                      selected={{ driverId: selectDriverValueId, driverName: selectDriverValueName }}
                      hasOptionRender={true}
                      hasFooterRender={true}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      onChangeValue={async (value: any, option: any, ref: any) => {
                        if(option){
                          setSelectDriverValueId(option?.map((x: any) => x.driverId));
                          setSelectDriverValueName(option?.map((x: any) => x.driverName));
                        } else {
                          setSelectDriverValueId([]);
                          setSelectDriverValueName([]);
                        }
                      }}

                      optionRender={(option: any, ref: any) => {
                        return <Row className={'align-items-center gx-2'}>
                          <Col xs={'auto'}>
                            {selectDriverValueId?.includes(option?.value) ? <CheckboxCheckedIcon className='position-relative' style={{ top: '-2' }} /> : <CheckboxUncheckedIcon className='position-relative' style={{ top: '-2' }} />}
                          </Col>
                          <Col xs={'auto'}>{option?.label}</Col>
                        </Row>
                      }}
                      footerRender={(isLoading: boolean, ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          disabled={isLoading}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();

                            if(ref){
                              if(ref?.getAllData().every((x: any) => selectDriverValueId?.includes(x.driverId))){
                                setSelectDriverValueId([]);
                                setSelectDriverValueName([]);
                              } else {
                                setSelectDriverValueId(ref?.getAllData()?.map((x: any) => x.driverId));
                                setSelectDriverValueName(ref?.getAllData()?.map((x: any) => x.driverName));
                              }
                            }
                          }}
                        >
                          {isLoading ? <CheckboxUncheckedIcon className='position-relative' style={{ top: '-2' }} /> : ref && ref?.getAllData()?.every((x: any) => selectDriverValueId?.includes(x.driverId)) ? <CheckboxCheckedIcon className='position-relative' style={{ top: '-2' }} /> : <CheckboxUncheckedIcon className='position-relative' style={{ top: '-2' }} />}
                          <span className='ps-2'>Select All</span>
                        </Button>
                      }}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={SmartSelect}
                      value={selectDriverValueId}
                      mode="multiple"
                      maxTagCount={'responsive'}
                      placeholder={'Select'}
                      addText={'Add new driver'}
                      apiPath={'driver'}
                      fieldNames={{ value: 'driverId', label: 'driverName' }}
                      selected={{ driverId: selectDriverValueId, driverName: selectDriverValueName }}
                      hasOptionRender={true}
                      hasFooterRender={true}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      onChangeValue={async (value: any, option: any, ref: any) => {
                        if(option){
                          setSelectDriverValueId(option?.map((x: any) => x.driverId));
                          setSelectDriverValueName(option?.map((x: any) => x.driverName));
                        } else {
                          setSelectDriverValueId([]);
                          setSelectDriverValueName([]);
                        }
                      }}

                      optionRender={(option: any, ref: any) => {
                        return <Row className={'align-items-center gx-2'}>
                          <Col xs={'auto'}>
                            {selectDriverValueId?.includes(option?.value) ? <CheckboxCheckedIcon className='position-relative' style={{ top: '-2' }} /> : <CheckboxUncheckedIcon className='position-relative' style={{ top: '-2' }} />}
                          </Col>
                          <Col xs={'auto'}>{option?.label}</Col>
                        </Row>
                      }}
                      footerRender={(isLoading: boolean, ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          disabled={isLoading}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();

                            if(ref){
                              if(ref?.getAllData().every((x: any) => selectDriverValueId?.includes(x.driverId))){
                                setSelectDriverValueId([]);
                                setSelectDriverValueName([]);
                              } else {
                                setSelectDriverValueId(ref?.getAllData()?.map((x: any) => x.driverId));
                                setSelectDriverValueName(ref?.getAllData()?.map((x: any) => x.driverName));
                              }
                            }
                          }}
                        >
                          {isLoading ? <CheckboxUncheckedIcon className='position-relative' style={{ top: '-2' }} /> : ref && ref?.getAllData()?.every((x: any) => selectDriverValueId?.includes(x.driverId)) ? <CheckboxCheckedIcon className='position-relative' style={{ top: '-2' }} /> : <CheckboxUncheckedIcon className='position-relative' style={{ top: '-2' }} />}
                          <span className='ps-2'>Select All</span>
                        </Button>
                      }}
                      isInvalid={true}
                    />
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={SmartSelect}
                      value={selectDriverValueId}
                      mode="multiple"
                      maxTagCount={'responsive'}
                      placeholder={'Select'}
                      addText={'Add new driver'}
                      apiPath={'driver'}
                      fieldNames={{ value: 'driverId', label: 'driverName' }}
                      selected={{ driverId: selectDriverValueId, driverName: selectDriverValueName }}
                      hasOptionRender={true}
                      hasFooterRender={true}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      onChangeValue={async (value: any, option: any, ref: any) => {
                        if(option){
                          setSelectDriverValueId(option?.map((x: any) => x.driverId));
                          setSelectDriverValueName(option?.map((x: any) => x.driverName));
                        } else {
                          setSelectDriverValueId([]);
                          setSelectDriverValueName([]);
                        }
                      }}

                      optionRender={(option: any, ref: any) => {
                        return <Row className={'align-items-center gx-2'}>
                          <Col xs={'auto'}>
                            {selectDriverValueId?.includes(option?.value) ? <CheckboxCheckedIcon className='position-relative' style={{ top: '-2' }} /> : <CheckboxUncheckedIcon className='position-relative' style={{ top: '-2' }} />}
                          </Col>
                          <Col xs={'auto'}>{option?.label}</Col>
                        </Row>
                      }}
                      footerRender={(isLoading: boolean, ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          disabled={isLoading}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();

                            if(ref){
                              if(ref?.getAllData().every((x: any) => selectDriverValueId?.includes(x.driverId))){
                                setSelectDriverValueId([]);
                                setSelectDriverValueName([]);
                              } else {
                                setSelectDriverValueId(ref?.getAllData()?.map((x: any) => x.driverId));
                                setSelectDriverValueName(ref?.getAllData()?.map((x: any) => x.driverName));
                              }
                            }
                          }}
                        >
                          {isLoading ? <CheckboxUncheckedIcon className='position-relative' style={{ top: '-2' }} /> : ref && ref?.getAllData()?.every((x: any) => selectDriverValueId?.includes(x.driverId)) ? <CheckboxCheckedIcon className='position-relative' style={{ top: '-2' }} /> : <CheckboxUncheckedIcon className='position-relative' style={{ top: '-2' }} />}
                          <span className='ps-2'>Select All</span>
                        </Button>
                      }}
                      isValid={true}
                    />
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={SmartSelect}
                      value={selectDriverValueId}
                      mode="multiple"
                      maxTagCount={'responsive'}
                      placeholder={'Select'}
                      addText={'Add new driver'}
                      apiPath={'driver'}
                      fieldNames={{ value: 'driverId', label: 'driverName' }}
                      selected={{ driverId: selectDriverValueId, driverName: selectDriverValueName }}
                      hasOptionRender={true}
                      hasFooterRender={true}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      onChangeValue={async (value: any, option: any, ref: any) => {
                        if(option){
                          setSelectDriverValueId(option?.map((x: any) => x.driverId));
                          setSelectDriverValueName(option?.map((x: any) => x.driverName));
                        } else {
                          setSelectDriverValueId([]);
                          setSelectDriverValueName([]);
                        }
                      }}

                      optionRender={(option: any, ref: any) => {
                        return <Row className={'align-items-center gx-2'}>
                          <Col xs={'auto'}>
                            {selectDriverValueId?.includes(option?.value) ? <CheckboxCheckedIcon className='position-relative' style={{ top: '-2' }} /> : <CheckboxUncheckedIcon className='position-relative' style={{ top: '-2' }} />}
                          </Col>
                          <Col xs={'auto'}>{option?.label}</Col>
                        </Row>
                      }}
                      footerRender={(isLoading: boolean, ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          disabled={isLoading}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();

                            if(ref){
                              if(ref?.getAllData().every((x: any) => selectDriverValueId?.includes(x.driverId))){
                                setSelectDriverValueId([]);
                                setSelectDriverValueName([]);
                              } else {
                                setSelectDriverValueId(ref?.getAllData()?.map((x: any) => x.driverId));
                                setSelectDriverValueName(ref?.getAllData()?.map((x: any) => x.driverName));
                              }
                            }
                          }}
                        >
                          {isLoading ? <CheckboxUncheckedIcon className='position-relative' style={{ top: '-2' }} /> : ref && ref?.getAllData()?.every((x: any) => selectDriverValueId?.includes(x.driverId)) ? <CheckboxCheckedIcon className='position-relative' style={{ top: '-2' }} /> : <CheckboxUncheckedIcon className='position-relative' style={{ top: '-2' }} />}
                          <span className='ps-2'>Select All</span>
                        </Button>
                      }}
                      disabled={true}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value={[]}
                      mode="tags"
                      placeholder={'Select'}
                      searchable={false}
                      allowClear={true}
                      selectedIcon={true}
                      loading={false}
                      open={false}
                      tokenSeparators={[',']}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                      ]}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value={[]}
                      mode="tags"
                      placeholder={'Select'}
                      searchable={false}
                      allowClear={true}
                      selectedIcon={true}
                      loading={false}
                      open={false}
                      tokenSeparators={[',']}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                      ]}
                      isInvalid={true}
                    />
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value={[]}
                      mode="tags"
                      placeholder={'Select'}
                      searchable={false}
                      allowClear={true}
                      selectedIcon={true}
                      loading={false}
                      open={false}
                      tokenSeparators={[',']}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                      ]}
                      isValid={true}
                    />
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Select}
                      value={[]}
                      mode="tags"
                      placeholder={'Select'}
                      searchable={false}
                      allowClear={true}
                      selectedIcon={true}
                      loading={false}
                      open={false}
                      tokenSeparators={[',']}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                      ]}
                      disabled={true}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>

            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Autocomplete">
            <Accordion.Header>Autocomplete</Accordion.Header>
            <Accordion.Body>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Autocomplete}
                      value="lucy"
                      placeholder={'Autocomplete'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={true}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Autocomplete}
                      value="lucy"
                      placeholder={'Autocomplete'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={true}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      isInvalid={true}
                    />
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Autocomplete}
                      value="lucy"
                      placeholder={'Autocomplete'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={true}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      isValid={true}
                    />
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Autocomplete}
                      value="lucy"
                      placeholder={'Autocomplete'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={true}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      disabled={true}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Autocomplete}
                      value="lucy"
                      placeholder={'Autocomplete'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      optionRender={(option: any, ref: any) => {
                        return <Row className={'g-2'}>
                          <Col xs={true}>{option.label}</Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-primary'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Edit2Icon />
                            </Button>
                          </Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-danger'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Trash2Icon />
                            </Button>
                          </Col>
                        </Row>
                      }}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Autocomplete}
                      value="lucy"
                      placeholder={'Autocomplete'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      optionRender={(option: any, ref: any) => {
                        return <Row className={'g-2'}>
                          <Col xs={true}>{option.label}</Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-primary'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Edit2Icon />
                            </Button>
                          </Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-danger'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Trash2Icon />
                            </Button>
                          </Col>
                        </Row>
                      }}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                      isInvalid={true}
                    />
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Autocomplete}
                      value="lucy"
                      placeholder={'Autocomplete'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      optionRender={(option: any, ref: any) => {
                        return <Row className={'g-2'}>
                          <Col xs={true}>{option.label}</Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-primary'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Edit2Icon />
                            </Button>
                          </Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-danger'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Trash2Icon />
                            </Button>
                          </Col>
                        </Row>
                      }}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                      isValid={true}
                    />
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Autocomplete}
                      value="lucy"
                      placeholder={'Autocomplete'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      loading={false}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      optionRender={(option: any, ref: any) => {
                        return <Row className={'g-2'}>
                          <Col xs={true}>{option.label}</Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-primary'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Edit2Icon />
                            </Button>
                          </Col>
                          <Col xs={'auto'}>
                            <Button
                              className={'ps-1'}
                              variant={'custom-icon-danger'}
                              disabled={option.data.disabled}
                              onClick={(e) => { 
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                            >
                              <Trash2Icon />
                            </Button>
                          </Col>
                        </Row>
                      }}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                      disabled={true}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Autocomplete}
                      value="lucy"
                      placeholder={'Autocomplete'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={true}
                      loading={true}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Autocomplete}
                      value="lucy"
                      placeholder={'Autocomplete'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={true}
                      loading={true}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                      isInvalid={true}
                    />
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Autocomplete}
                      value="lucy"
                      placeholder={'Autocomplete'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={true}
                      loading={true}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                      isValid={true}
                    />
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={Autocomplete}
                      value="lucy"
                      placeholder={'Autocomplete'}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={true}
                      loading={true}
                      onDropdownVisibleChange={(open: any, ref: any) => {
                        if(open){
                          console.info('⚡ | open:', open);
                        }
                      }}
                      onChangeValue={(value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option);
                      }}
                      onSearch={(e: any, ref: any) => {
                        console.info('⚡ onSearch | e:', e.target.value);
                      }}
                      options={[
                        { value: 'jack', label: 'Jack' },
                        { value: 'lucy', label: 'Lucy' },
                        { value: 'Yiminghe', label: 'yiminghe' },
                        { value: 'disabled', label: 'Disabled', disabled: true },
                      ]}
                      footer={(ref: any) => {
                        return <Button
                          variant={'custom-text'}
                          size={'sm'}
                          onClick={(e) => { 
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                        ><PlusIcon /> Add new category</Button>
                      }}
                      disabled={true}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={SmartAutocomplete}
                      value={selectValueId}
                      placeholder={'Autocomplete'}
                      addText={'Add new group'}
                      apiPath={'vehicle-group'}
                      fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                      selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                      hasOptionRender={true}
                      hasFooterRender={true}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      onChangeValue={async (value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option, ref);
                        if(option){
                          setSelectValueId(value);
                          setSelectValueName(option.label);
                        } else {
                          setSelectValueId(null);
                          setSelectValueName('');
                        }
                      }}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={SmartAutocomplete}
                      value={selectValueId}
                      placeholder={'Autocomplete'}
                      addText={'Add new group'}
                      apiPath={'vehicle-group'}
                      fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                      selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                      hasOptionRender={true}
                      hasFooterRender={true}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      onChangeValue={async (value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option, ref);
                        if(option){
                          setSelectValueId(value);
                          setSelectValueName(option.label);
                        } else {
                          setSelectValueId(null);
                          setSelectValueName('');
                        }
                      }}
                      isInvalid={true}
                    />
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={SmartAutocomplete}
                      value={selectValueId}
                      placeholder={'Autocomplete'}
                      addText={'Add new group'}
                      apiPath={'vehicle-group'}
                      fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                      selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                      hasOptionRender={true}
                      hasFooterRender={true}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      onChangeValue={async (value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option, ref);
                        if(option){
                          setSelectValueId(value);
                          setSelectValueName(option.label);
                        } else {
                          setSelectValueId(null);
                          setSelectValueName('');
                        }
                      }}
                      isValid={true}
                    />
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={SmartAutocomplete}
                      value={selectValueId}
                      placeholder={'Autocomplete'}
                      addText={'Add new group'}
                      apiPath={'vehicle-group'}
                      fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                      selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                      hasOptionRender={true}
                      hasFooterRender={true}
                      searchable={true}
                      allowClear={true}
                      selectedIcon={false}
                      onChangeValue={async (value: any, option: any, ref: any) => {
                        console.info(`selected ${value}`, option, ref);
                        if(option){
                          setSelectValueId(value);
                          setSelectValueName(option.label);
                        } else {
                          setSelectValueId(null);
                          setSelectValueName('');
                        }
                      }}
                      disabled={true}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as={SmartAutocomplete}
                        value={selectValueName}
                        placeholder={'Autocomplete'}
                        addText={'Add new group'}
                        apiPath={'vehicle-group'}
                        fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                        selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                        hasOptionRender={false}
                        hasFooterRender={true}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={false}
                        onChangeValue={async (value: any, option: any, ref: any) => {
                          console.info(`selected ${value}`, option, ref);
                          if(option){
                            setSelectValueId(value);
                            setSelectValueName(option.vehicleGroupName);
                          } else {
                            setSelectValueId(null);
                            setSelectValueName('');
                          }
                        }}
                        footerRender={(isLoading: boolean, ref: any) => {
                          return <Button
                            variant={'custom-text'}
                            size={'sm'}
                            disabled={isLoading}
                            onClick={(e) => { 
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                          ><PlusIcon /> Add new route</Button>
                        }}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as={SmartAutocomplete}
                        value={selectValueName}
                        placeholder={'Autocomplete'}
                        addText={'Add new group'}
                        apiPath={'vehicle-group'}
                        fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                        selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                        hasOptionRender={false}
                        hasFooterRender={true}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={false}
                        onChangeValue={async (value: any, option: any, ref: any) => {
                          console.info(`selected ${value}`, option, ref);
                          if(option){
                            setSelectValueId(value);
                            setSelectValueName(option.vehicleGroupName);
                          } else {
                            setSelectValueId(null);
                            setSelectValueName('');
                          }
                        }}
                        footerRender={(isLoading: boolean, ref: any) => {
                          return <Button
                            variant={'custom-text'}
                            size={'sm'}
                            disabled={isLoading}
                            onClick={(e) => { 
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                          ><PlusIcon /> Add new route</Button>
                        }}
                        isInvalid={true}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                      <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as={SmartAutocomplete}
                        value={selectValueName}
                        placeholder={'Autocomplete'}
                        addText={'Add new group'}
                        apiPath={'vehicle-group'}
                        fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                        selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                        hasOptionRender={false}
                        hasFooterRender={true}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={false}
                        onChangeValue={async (value: any, option: any, ref: any) => {
                          console.info(`selected ${value}`, option, ref);
                          if(option){
                            setSelectValueId(value);
                            setSelectValueName(option.vehicleGroupName);
                          } else {
                            setSelectValueId(null);
                            setSelectValueName('');
                          }
                        }}
                        footerRender={(isLoading: boolean, ref: any) => {
                          return <Button
                            variant={'custom-text'}
                            size={'sm'}
                            disabled={isLoading}
                            onClick={(e) => { 
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                          ><PlusIcon /> Add new route</Button>
                        }}
                        isValid={true}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                      <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as={SmartAutocomplete}
                        value={selectValueName}
                        placeholder={'Autocomplete'}
                        addText={'Add new group'}
                        apiPath={'vehicle-group'}
                        fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                        selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                        hasOptionRender={false}
                        hasFooterRender={true}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={false}
                        onChangeValue={async (value: any, option: any, ref: any) => {
                          console.info(`selected ${value}`, option, ref);
                          if(option){
                            setSelectValueId(value);
                            setSelectValueName(option.vehicleGroupName);
                          } else {
                            setSelectValueId(null);
                            setSelectValueName('');
                          }
                        }}
                        footerRender={(isLoading: boolean, ref: any) => {
                          return <Button
                            variant={'custom-text'}
                            size={'sm'}
                            disabled={isLoading}
                            onClick={(e) => { 
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                          ><PlusIcon /> Add new route</Button>
                        }}
                        disabled={true}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'} disabled={true}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text className={'border-end'}>
                        <ColorPicker
                          value={selectedColor}
                          onChange={(val: any) => {
                            console.info(val);
                            setSelectedColor(val)
                          }}
                        />
                      </InputGroup.Text>
                      <Form.Control
                        as={SmartAutocomplete}
                        value={selectValueName}
                        placeholder={'Autocomplete'}
                        addText={'Add new group'}
                        apiPath={'vehicle-group'}
                        fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                        selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                        hasOptionRender={false}
                        hasFooterRender={true}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={false}
                        onChangeValue={async (value: any, option: any, ref: any) => {
                          console.info(`selected ${value}`, option, ref);
                          if(option){
                            setSelectValueId(value);
                            setSelectValueName(option.vehicleGroupName);
                          } else {
                            setSelectValueId(null);
                            setSelectValueName('');
                          }
                        }}
                        footerRender={(isLoading: boolean, ref: any) => {
                          return <Button
                            variant={'custom-text'}
                            size={'sm'}
                            disabled={isLoading}
                            onClick={(e) => { 
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                          ><PlusIcon /> Add new route</Button>
                        }}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text className={'border-end'}>
                        <ColorPicker
                          value={selectedColor}
                          onChange={(val: any) => {
                            console.info(val);
                            setSelectedColor(val)
                          }}
                        />
                      </InputGroup.Text>
                      <Form.Control
                        as={SmartAutocomplete}
                        value={selectValueName}
                        placeholder={'Autocomplete'}
                        addText={'Add new group'}
                        apiPath={'vehicle-group'}
                        fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                        selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                        hasOptionRender={false}
                        hasFooterRender={true}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={false}
                        onChangeValue={async (value: any, option: any, ref: any) => {
                          console.info(`selected ${value}`, option, ref);
                          if(option){
                            setSelectValueId(value);
                            setSelectValueName(option.vehicleGroupName);
                          } else {
                            setSelectValueId(null);
                            setSelectValueName('');
                          }
                        }}
                        footerRender={(isLoading: boolean, ref: any) => {
                          return <Button
                            variant={'custom-text'}
                            size={'sm'}
                            disabled={isLoading}
                            onClick={(e) => { 
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                          ><PlusIcon /> Add new route</Button>
                        }}
                        isInvalid={true}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                      <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text className={'border-end'}>
                        <ColorPicker
                          value={selectedColor}
                          onChange={(val: any) => {
                            console.info(val);
                            setSelectedColor(val)
                          }}
                        />
                      </InputGroup.Text>
                      <Form.Control
                        as={SmartAutocomplete}
                        value={selectValueName}
                        placeholder={'Autocomplete'}
                        addText={'Add new group'}
                        apiPath={'vehicle-group'}
                        fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                        selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                        hasOptionRender={false}
                        hasFooterRender={true}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={false}
                        onChangeValue={async (value: any, option: any, ref: any) => {
                          console.info(`selected ${value}`, option, ref);
                          if(option){
                            setSelectValueId(value);
                            setSelectValueName(option.vehicleGroupName);
                          } else {
                            setSelectValueId(null);
                            setSelectValueName('');
                          }
                        }}
                        footerRender={(isLoading: boolean, ref: any) => {
                          return <Button
                            variant={'custom-text'}
                            size={'sm'}
                            disabled={isLoading}
                            onClick={(e) => { 
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                          ><PlusIcon /> Add new route</Button>
                        }}
                        isValid={true}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                      <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text className={'border-end'}>
                        <ColorPicker
                          disabled={true}
                          value={selectedColor}
                          onChange={(val: any) => {
                            console.info(val);
                            setSelectedColor(val)
                          }}
                        />
                      </InputGroup.Text>
                      <Form.Control
                        as={SmartAutocomplete}
                        value={selectValueName}
                        placeholder={'Autocomplete'}
                        addText={'Add new group'}
                        apiPath={'vehicle-group'}
                        fieldNames={{ value: 'vehicleGroupId', label: 'vehicleGroupName' }}
                        selected={{ vehicleGroupId: selectValueId, vehicleGroupName: selectValueName }}
                        hasOptionRender={false}
                        hasFooterRender={true}
                        searchable={true}
                        allowClear={true}
                        selectedIcon={false}
                        onChangeValue={async (value: any, option: any, ref: any) => {
                          console.info(`selected ${value}`, option, ref);
                          if(option){
                            setSelectValueId(value);
                            setSelectValueName(option.vehicleGroupName);
                          } else {
                            setSelectValueId(null);
                            setSelectValueName('');
                          }
                        }}
                        footerRender={(isLoading: boolean, ref: any) => {
                          return <Button
                            variant={'custom-text'}
                            size={'sm'}
                            disabled={isLoading}
                            onClick={(e) => { 
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                          ><PlusIcon /> Add new route</Button>
                        }}
                        disabled={true}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'} disabled={true}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>

            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="GoogleAddress">
            <Accordion.Header>Google Address</Accordion.Header>
            <Accordion.Body>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={GoogleSearchAddress}
                      autoComplete='off'
                      placeholder={'Google Search Address'}
                      onPlaceSelected={(place: any) => {
                        let obj = getAddressPlace(place);
                        console.info('⚡ | place:', place, obj);
                      }}
                      onChange={(e) => {
                        console.info('⚡ | e.target.value:', e.target.value);
                      }}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={GoogleSearchAddress}
                      autoComplete='off'
                      placeholder={'Google Search Address'}
                      isInvalid={true}
                      onPlaceSelected={(place: any) => {
                        let obj = getAddressPlace(place);
                        console.info('⚡ | place:', place, obj);
                      }}
                      onChange={(e) => {
                        console.info('⚡ | e.target.value:', e.target.value);
                      }}
                    />
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={GoogleSearchAddress}
                      autoComplete='off'
                      placeholder={'Google Search Address'}
                      isValid={true}
                      onPlaceSelected={(place: any) => {
                        let obj = getAddressPlace(place);
                        console.info('⚡ | place:', place, obj);
                      }}
                      onChange={(e) => {
                        console.info('⚡ | e.target.value:', e.target.value);
                      }}
                    />
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <Form.Control
                      as={GoogleSearchAddress}
                      autoComplete='off'
                      placeholder={'Google Search Address'}
                      disabled={true}
                      onPlaceSelected={(place: any) => {
                        let obj = getAddressPlace(place);
                        console.info('⚡ | place:', place, obj);
                      }}
                      onChange={(e) => {
                        console.info('⚡ | e.target.value:', e.target.value);
                      }}
                    />
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as={GoogleSearchAddress}
                        autoComplete='off'
                        placeholder={'Google Search Address'}
                        onPlaceSelected={(place: any) => {
                          let obj = getAddressPlace(place);
                          console.info('⚡ | place:', place, obj);
                        }}
                        onChange={(e) => {
                          console.info('⚡ | e.target.value:', e.target.value);
                        }}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as={GoogleSearchAddress}
                        autoComplete='off'
                        placeholder={'Google Search Address'}
                        isInvalid={true}
                        onPlaceSelected={(place: any) => {
                          let obj = getAddressPlace(place);
                          console.info('⚡ | place:', place, obj);
                        }}
                        onChange={(e) => {
                          console.info('⚡ | e.target.value:', e.target.value);
                        }}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as={GoogleSearchAddress}
                        autoComplete='off'
                        placeholder={'Google Search Address'}
                        isValid={true}
                        onPlaceSelected={(place: any) => {
                          let obj = getAddressPlace(place);
                          console.info('⚡ | place:', place, obj);
                        }}
                        onChange={(e) => {
                          console.info('⚡ | e.target.value:', e.target.value);
                        }}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        as={GoogleSearchAddress}
                        autoComplete='off'
                        placeholder={'Google Search Address'}
                        disabled={true}
                        onPlaceSelected={(place: any) => {
                          let obj = getAddressPlace(place);
                          console.info('⚡ | place:', place, obj);
                        }}
                        onChange={(e) => {
                          console.info('⚡ | e.target.value:', e.target.value);
                        }}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'} disabled={true}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text className={'border-end'}>
                        <ColorPicker
                          value={selectedColor}
                          onChange={(val: any) => {
                            console.info(val);
                            setSelectedColor(val)
                          }}
                        />
                      </InputGroup.Text>
                      <Form.Control
                        as={GoogleSearchAddress}
                        autoComplete='off'
                        placeholder={'Google Search Address'}
                        onPlaceSelected={(place: any) => {
                          let obj = getAddressPlace(place);
                          console.info('⚡ | place:', place, obj);
                        }}
                        onChange={(e) => {
                          console.info('⚡ | e.target.value:', e.target.value);
                        }}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text className={'border-end'}>
                        <ColorPicker
                          value={selectedColor}
                          onChange={(val: any) => {
                            console.info(val);
                            setSelectedColor(val)
                          }}
                        />
                      </InputGroup.Text>
                      <Form.Control
                        as={GoogleSearchAddress}
                        autoComplete='off'
                        placeholder={'Google Search Address'}
                        isInvalid={true}
                        onPlaceSelected={(place: any) => {
                          let obj = getAddressPlace(place);
                          console.info('⚡ | place:', place, obj);
                        }}
                        onChange={(e) => {
                          console.info('⚡ | e.target.value:', e.target.value);
                        }}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="invalid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text className={'border-end'}>
                        <ColorPicker
                          value={selectedColor}
                          onChange={(val: any) => {
                            console.info(val);
                            setSelectedColor(val)
                          }}
                        />
                      </InputGroup.Text>
                      <Form.Control
                        as={GoogleSearchAddress}
                        autoComplete='off'
                        placeholder={'Google Search Address'}
                        isValid={true}
                        onPlaceSelected={(place: any) => {
                          let obj = getAddressPlace(place);
                          console.info('⚡ | place:', place, obj);
                        }}
                        onChange={(e) => {
                          console.info('⚡ | e.target.value:', e.target.value);
                        }}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Control.Feedback type="valid">Input helper text</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group>
                    <Form.Label disabled={true}>
                      Input label
                      <Button
                        className={'ps-1'}
                        size={'sm'}
                        variant={'custom-none-primary'}
                        disabled={true}
                        onClick={(e) => { 
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <EditIcon />
                      </Button>
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text className={'border-end'}>
                        <ColorPicker
                          disabled={true}
                          value={selectedColor}
                          onChange={(val: any) => {
                            console.info(val);
                            setSelectedColor(val)
                          }}
                        />
                      </InputGroup.Text>
                      <Form.Control
                        as={GoogleSearchAddress}
                        autoComplete='off'
                        placeholder={'Google Search Address'}
                        disabled={true}
                        onPlaceSelected={(place: any) => {
                          let obj = getAddressPlace(place);
                          console.info('⚡ | place:', place, obj);
                        }}
                        onChange={(e) => {
                          console.info('⚡ | e.target.value:', e.target.value);
                        }}
                      />
                      <InputGroup.Text>
                        <Button variant={'custom-none-primary'} disabled={true}><MapPinIcon /></Button>
                      </InputGroup.Text>
                    </InputGroup>
                    <Form.Text>Input helper text</Form.Text>
                  </Form.Group>
                </Col>
              </Row>

            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Dropdown">
            <Accordion.Header>Dropdown</Accordion.Header>
            <Accordion.Body>

              <Row className='mb-5'>
                <Col xs={12} md={2}>
                  <DropdownButton
                    variant={'custom-outlined'}
                    size={'sm'}
                    title={'Dropdown'}
                  >
                    <Dropdown.Item
                      active={false}
                      onClick={() => {
                        
                      }}
                    >Item 1</Dropdown.Item>
                    <Dropdown.Item
                      active={true}
                      onClick={() => {
                        
                      }}
                    >Item 2</Dropdown.Item>
                    <Dropdown.Item
                      active={false}
                      onClick={() => {
                        
                      }}
                    >Item 1</Dropdown.Item>
                  </DropdownButton>
                </Col>
                <Col xs={12} md={2}>
                  <DropdownButton
                    variant={'custom-primary'}
                    size={'sm'}
                    title={'Dropdown'}
                  >
                    <Dropdown.Item
                      active={false}
                      onClick={() => {
                        
                      }}
                    >Item 1</Dropdown.Item>
                    <Dropdown.Item
                      active={true}
                      onClick={() => {
                        
                      }}
                    >Item 2</Dropdown.Item>
                    <Dropdown.Item
                      active={false}
                      onClick={() => {
                        
                      }}
                    >Item 1</Dropdown.Item>
                  </DropdownButton>
                </Col>
                <Col xs={12} md={2}>
                  <DropdownButton
                    variant={'custom-danger'}
                    size={'sm'}
                    title={'Dropdown'}
                  >
                    <Dropdown.Item
                      active={false}
                      onClick={() => {
                        
                      }}
                    >Item 1</Dropdown.Item>
                    <Dropdown.Item
                      active={true}
                      onClick={() => {
                        
                      }}
                    >Item 2</Dropdown.Item>
                    <Dropdown.Item
                      active={false}
                      onClick={() => {
                        
                      }}
                    >Item 1</Dropdown.Item>
                  </DropdownButton>
                </Col>
                <Col xs={12} md={2}>
                  <DropdownButton
                    variant={'custom-success'}
                    size={'sm'}
                    title={'Dropdown'}
                  >
                    <Dropdown.Item
                      active={false}
                      onClick={() => {
                        
                      }}
                    >Item 1</Dropdown.Item>
                    <Dropdown.Item
                      active={true}
                      onClick={() => {
                        
                      }}
                    >Item 2</Dropdown.Item>
                    <Dropdown.Item
                      active={false}
                      onClick={() => {
                        
                      }}
                    >Item 1</Dropdown.Item>
                  </DropdownButton>
                </Col>
                <Col xs={12} md={2}>
                  <DropdownButton
                    variant={'custom-secondary'}
                    size={'sm'}
                    title={'Dropdown'}
                  >
                    <Dropdown.Item
                      active={false}
                      onClick={() => {
                        
                      }}
                    >Item 1</Dropdown.Item>
                    <Dropdown.Item
                      active={true}
                      onClick={() => {
                        
                      }}
                    >Item 2</Dropdown.Item>
                    <Dropdown.Item
                      active={false}
                      onClick={() => {
                        
                      }}
                    >Item 1</Dropdown.Item>
                  </DropdownButton>
                </Col>
                <Col xs={12} md={2}>
                  <DropdownButton
                    variant={'custom-none-primary'}
                    size={'sm'}
                    title={'Dropdown'}
                  >
                    <Dropdown.Item
                      active={false}
                      onClick={() => {
                        
                      }}
                    >Item 1</Dropdown.Item>
                    <Dropdown.Item
                      active={true}
                      onClick={() => {
                        
                      }}
                    >Item 2</Dropdown.Item>
                    <Dropdown.Item
                      active={false}
                      onClick={() => {
                        
                      }}
                    >Item 1</Dropdown.Item>
                  </DropdownButton>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={2}>
                  <Dropdown as={ButtonGroup} align="end">
                    <Button 
                      variant={'custom-outlined'}
                      size={'sm'}
                    >Dropdown</Button>

                    <Dropdown.Toggle 
                      variant={'custom-outlined'}
                      size={'sm'}
                      split
                    />

                    <Dropdown.Menu>
                      <Dropdown.Item
                        active={false}
                        onClick={() => {
                          
                        }}
                      >Item 1</Dropdown.Item>
                      <Dropdown.Item
                        active={true}
                        onClick={() => {
                          
                        }}
                      >Item 2</Dropdown.Item>
                      <Dropdown.Item
                        active={false}
                        onClick={() => {
                          
                        }}
                      >Item 1</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Col>
                <Col xs={12} md={2}>
                  <Dropdown as={ButtonGroup} align="end">
                    <Button 
                      variant={'custom-primary'}
                      size={'sm'}
                    >Dropdown</Button>

                    <Dropdown.Toggle 
                      variant={'custom-primary'}
                      size={'sm'}
                      split
                    />

                    <Dropdown.Menu>
                      <Dropdown.Item
                        active={false}
                        onClick={() => {
                          
                        }}
                      >Item 1</Dropdown.Item>
                      <Dropdown.Item
                        active={true}
                        onClick={() => {
                          
                        }}
                      >Item 2</Dropdown.Item>
                      <Dropdown.Item
                        active={false}
                        onClick={() => {
                          
                        }}
                      >Item 1</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Col>
                <Col xs={12} md={2}>
                  <Dropdown as={ButtonGroup} align="end">
                    <Button 
                      variant={'custom-danger'}
                      size={'sm'}
                    >Dropdown</Button>

                    <Dropdown.Toggle 
                      variant={'custom-danger'}
                      size={'sm'}
                      split
                    />

                    <Dropdown.Menu>
                      <Dropdown.Item
                        active={false}
                        onClick={() => {
                          
                        }}
                      >Item 1</Dropdown.Item>
                      <Dropdown.Item
                        active={true}
                        onClick={() => {
                          
                        }}
                      >Item 2</Dropdown.Item>
                      <Dropdown.Item
                        active={false}
                        onClick={() => {
                          
                        }}
                      >Item 1</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Col>
                <Col xs={12} md={2}>
                  <Dropdown as={ButtonGroup} align="end">
                    <Button 
                      variant={'custom-success'}
                      size={'sm'}
                    >Dropdown</Button>

                    <Dropdown.Toggle 
                      variant={'custom-success'}
                      size={'sm'}
                      split
                    />

                    <Dropdown.Menu>
                      <Dropdown.Item
                        active={false}
                        onClick={() => {
                          
                        }}
                      >Item 1</Dropdown.Item>
                      <Dropdown.Item
                        active={true}
                        onClick={() => {
                          
                        }}
                      >Item 2</Dropdown.Item>
                      <Dropdown.Item
                        active={false}
                        onClick={() => {
                          
                        }}
                      >Item 1</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Col>
                <Col xs={12} md={2}>
                  <Dropdown as={ButtonGroup} align="end">
                    <Button 
                      variant={'custom-secondary'}
                      size={'sm'}
                    >Dropdown</Button>

                    <Dropdown.Toggle 
                      variant={'custom-secondary'}
                      size={'sm'}
                      split
                    />

                    <Dropdown.Menu>
                      <Dropdown.Item
                        active={false}
                        onClick={() => {
                          
                        }}
                      >Item 1</Dropdown.Item>
                      <Dropdown.Item
                        active={true}
                        onClick={() => {
                          
                        }}
                      >Item 2</Dropdown.Item>
                      <Dropdown.Item
                        active={false}
                        onClick={() => {
                          
                        }}
                      >Item 1</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Col>
                <Col xs={12} md={2}>
                  <Dropdown as={ButtonGroup} align="end">
                    <Button 
                      variant={'custom-none-primary'}
                      size={'sm'}
                    >Dropdown</Button>

                    <Dropdown.Toggle 
                      variant={'custom-none-primary'}
                      size={'sm'}
                      split
                    />

                    <Dropdown.Menu>
                      <Dropdown.Item
                        active={false}
                        onClick={() => {
                          
                        }}
                      >Item 1</Dropdown.Item>
                      <Dropdown.Item
                        active={true}
                        onClick={() => {
                          
                        }}
                      >Item 2</Dropdown.Item>
                      <Dropdown.Item
                        active={false}
                        onClick={() => {
                          
                        }}
                      >Item 1</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Col>
              </Row>

            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Checkbox">
            <Accordion.Header>Checkbox</Accordion.Header>
            <Accordion.Body>

              <Row className='mb-5'>
                <Col xs={12} md={4}>
                  <Checkbox
                    checked={true}
                    onChange={(e) => {
                      console.info(`checked = ${e.target.checked}`);
                    }}
                  >Checkbox</Checkbox>
                </Col>
                <Col xs={12} md={4}>
                  <Checkbox
                    checked={false}
                    indeterminate={true}
                    onChange={(e) => {
                      console.info(`checked = ${e.target.checked}`);
                    }}
                  >Checkbox</Checkbox>
                </Col>
                <Col xs={12} md={4}>
                  <Checkbox
                    checked={false}
                    onChange={(e) => {
                      console.info(`checked = ${e.target.checked}`);
                    }}
                  >Checkbox</Checkbox>
                </Col>

                <Col xs={12} md={4}>
                  <Checkbox
                    checked={true}
                    onChange={(e) => {
                      console.info(`checked = ${e.target.checked}`);
                    }}
                    disabled={true}
                  >Checkbox</Checkbox>
                </Col>
                <Col xs={12} md={4}>
                  <Checkbox
                    checked={false}
                    indeterminate={true}
                    onChange={(e) => {
                      console.info(`checked = ${e.target.checked}`);
                    }}
                    disabled={true}
                  >Checkbox</Checkbox>
                </Col>
                <Col xs={12} md={4}>
                  <Checkbox
                    checked={false}
                    onChange={(e) => {
                      console.info(`checked = ${e.target.checked}`);
                    }}
                    disabled={true}
                  >Checkbox</Checkbox>
                </Col>
              </Row>
              
              <Row className='mb-5'>
                <Col xs={12} md={4}>
                  <Checkbox
                    className='sm'
                    checked={true}
                    onChange={(e) => {
                      console.info(`checked = ${e.target.checked}`);
                    }}
                  >Checkbox</Checkbox>
                </Col>
                <Col xs={12} md={4}>
                  <Checkbox
                    className='sm'
                    checked={false}
                    indeterminate={true}
                    onChange={(e) => {
                      console.info(`checked = ${e.target.checked}`);
                    }}
                  >Checkbox</Checkbox>
                </Col>
                <Col xs={12} md={4}>
                  <Checkbox
                    className='sm'
                    checked={false}
                    onChange={(e) => {
                      console.info(`checked = ${e.target.checked}`);
                    }}
                  >Checkbox</Checkbox>
                </Col>

                <Col xs={12} md={4}>
                  <Checkbox
                    className='sm'
                    checked={true}
                    onChange={(e) => {
                      console.info(`checked = ${e.target.checked}`);
                    }}
                    disabled={true}
                  >Checkbox</Checkbox>
                </Col>
                <Col xs={12} md={4}>
                  <Checkbox
                    className='sm'
                    checked={false}
                    indeterminate={true}
                    onChange={(e) => {
                      console.info(`checked = ${e.target.checked}`);
                    }}
                    disabled={true}
                  >Checkbox</Checkbox>
                </Col>
                <Col xs={12} md={4}>
                  <Checkbox
                    className='sm'
                    checked={false}
                    onChange={(e) => {
                      console.info(`checked = ${e.target.checked}`);
                    }}
                    disabled={true}
                  >Checkbox</Checkbox>
                </Col>
              </Row>


              <Row className='mb-5'>
                <Col xs={12} md={4}>
                  <Form.Group className='checkbox-field'>
                    <Checkbox
                      checked={true}
                      onChange={(e) => {
                        console.info(`checked = ${e.target.checked}`);
                      }}
                    >Checkbox</Checkbox>
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className='checkbox-field'>
                    <Checkbox
                      checked={false}
                      indeterminate={true}
                      onChange={(e) => {
                        console.info(`checked = ${e.target.checked}`);
                      }}
                    >Checkbox</Checkbox>
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className='checkbox-field'>
                    <Checkbox
                      checked={false}
                      onChange={(e) => {
                        console.info(`checked = ${e.target.checked}`);
                      }}
                    >Checkbox</Checkbox>
                  </Form.Group>
                </Col>

                <Col xs={12} md={4}>
                  <Form.Group className='checkbox-field'>
                    <Checkbox
                      className='sm'
                      checked={true}
                      onChange={(e) => {
                        console.info(`checked = ${e.target.checked}`);
                      }}
                      disabled={true}
                    >Checkbox</Checkbox>
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className='checkbox-field'>
                    <Checkbox
                      className='sm'
                      checked={false}
                      indeterminate={true}
                      onChange={(e) => {
                        console.info(`checked = ${e.target.checked}`);
                      }}
                      disabled={true}
                    >Checkbox</Checkbox>
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className='checkbox-field'>
                    <Checkbox
                      className='sm'
                      checked={false}
                      onChange={(e) => {
                        console.info(`checked = ${e.target.checked}`);
                      }}
                      disabled={true}
                    >Checkbox</Checkbox>
                  </Form.Group>
                </Col>
              </Row>

            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Radio">
            <Accordion.Header>Radio</Accordion.Header>
            <Accordion.Body>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Radio
                    checked={true}
                    onChange={(e) => {
                      console.info(`checked = ${e.target.checked}`);
                    }}
                  >Radio</Radio>
                </Col>
                <Col xs={12} md={3}>
                  <Radio
                    checked={false}
                    onChange={(e) => {
                      console.info(`checked = ${e.target.checked}`);
                    }}
                  >Radio</Radio>
                </Col>
                <Col xs={12} md={3}>
                  <Radio
                    checked={true}
                    onChange={(e) => {
                      console.info(`checked = ${e.target.checked}`);
                    }}
                    disabled={true}
                  >Radio</Radio>
                </Col>
                <Col xs={12} md={3}>
                  <Radio
                    checked={false}
                    onChange={(e) => {
                      console.info(`checked = ${e.target.checked}`);
                    }}
                    disabled={true}
                  >Radio</Radio>
                </Col>
              </Row>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group className='checkbox-field'>
                    <Radio
                      checked={true}
                      onChange={(e) => {
                        console.info(`checked = ${e.target.checked}`);
                      }}
                    >Radio</Radio>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group className='checkbox-field'>
                    <Radio
                      checked={false}
                      onChange={(e) => {
                        console.info(`checked = ${e.target.checked}`);
                      }}
                    >Radio</Radio>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group className='checkbox-field'>
                    <Radio
                      checked={true}
                      onChange={(e) => {
                        console.info(`checked = ${e.target.checked}`);
                      }}
                      disabled={true}
                    >Radio</Radio>
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group className='checkbox-field'>
                    <Radio
                      checked={false}
                      onChange={(e) => {
                        console.info(`checked = ${e.target.checked}`);
                      }}
                      disabled={true}
                    >Radio</Radio>
                  </Form.Group>
                </Col>
              </Row>

            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Switch">
            <Accordion.Header>Switch</Accordion.Header>
            <Accordion.Body>

              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Switch
                    checked={true}
                    onChange={(checked) => {
                      console.info(`checked = ${checked}`);
                    }}
                  />
                </Col>
                <Col xs={12} md={3}>
                  <Switch
                    checked={false}
                    onChange={(checked) => {
                      console.info(`checked = ${checked}`);
                    }}
                  />
                </Col>
                <Col xs={12} md={3}>
                  <Switch
                    checked={true}
                    onChange={(checked) => {
                      console.info(`checked = ${checked}`);
                    }}
                    disabled={true}
                  />
                </Col>
                <Col xs={12} md={3}>
                  <Switch
                    checked={false}
                    onChange={(checked) => {
                      console.info(`checked = ${checked}`);
                    }}
                    disabled={true}
                  />
                </Col>
              </Row>
              
              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Form.Group className='checkbox-field'>
                    <Switch
                      checked={true}
                      onChange={(checked) => {
                        console.info(`checked = ${checked}`);
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group className='checkbox-field'>
                    <Switch
                      checked={false}
                      onChange={(checked) => {
                        console.info(`checked = ${checked}`);
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group className='checkbox-field'>
                    <Switch
                      checked={true}
                      onChange={(checked) => {
                        console.info(`checked = ${checked}`);
                      }}
                      disabled={true}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={3}>
                  <Form.Group className='checkbox-field'>
                    <Switch
                      checked={false}
                      onChange={(checked) => {
                        console.info(`checked = ${checked}`);
                      }}
                      disabled={true}
                    />
                  </Form.Group>
                </Col>
              </Row>

            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Dropzone">
            <Accordion.Header>Dropzone</Accordion.Header>
            <Accordion.Body>

              <Row className='mb-5'>
                <Col xs={12}>
                  <div>Single</div>
                  <Dropzone
                    accept={'image/jpeg,image/jpg,image/png'}
                    acceptText={'.jpeg, .jpg, .png'}
                    method={'post'}
                    name={'file'}
                    action={'https://docgen-api.logisfleet.com/api/doc-generation-job/upload-file'}
                    headers={{
                      'UploadPath': 'tranzporter/test/attachment/',
                      'Authorization': 'mWU89QAnk0ik'
                    }}
                    maxCount={1}
                    maxSize={null}
                    multiple={false}
                    showDownload={true}
                    canCrop={true}
                    files={singleFileList}
                    onChange={({ fileList: newFileList }: any) => {
                      setSingleFileList(newFileList)
                    }}
                  />
                </Col>
                <Col xs={12}>
                  <div>Max 3 images</div>
                  <Dropzone
                    accept={'image/jpeg,image/jpg,image/png'}
                    acceptText={'.jpeg, .jpg, .png'}
                    method={'post'}
                    name={'file'}
                    action={'https://docgen-api.logisfleet.com/api/doc-generation-job/upload-file'}
                    headers={{
                      'UploadPath': 'tranzporter/test/attachment/',
                      'Authorization': 'mWU89QAnk0ik'
                    }}
                    maxCount={3}
                    maxSize={1}
                    multiple={false}
                    showDownload={true}
                    canCrop={true}
                    files={threeFileList}
                    onChange={({ fileList: newFileList }: any) => {
                      setThreeFileList(newFileList)
                    }}
                  />
                </Col>
                <Col xs={12}>
                  <div>Multiple</div>
                  <Dropzone
                    accept={'image/jpeg,image/jpg,image/png'}
                    acceptText={'.jpeg, .jpg, .png'}
                    method={'post'}
                    name={'file'}
                    action={'https://docgen-api.logisfleet.com/api/doc-generation-job/upload-file'}
                    headers={{
                      'UploadPath': 'tranzporter/test/attachment/',
                      'Authorization': 'mWU89QAnk0ik'
                    }}
                    maxCount={null}
                    maxSize={null}
                    multiple={true}
                    showDownload={false}
                    canCrop={false}
                    files={multipleFileList}
                    onChange={({ fileList: newFileList }: any) => {
                      setMultipleFileList(newFileList)
                    }}
                  />
                </Col>
                <Col xs={12}>
                  <div>Disabled</div>
                  <Dropzone
                    accept={'image/jpeg,image/jpg,image/png'}
                    acceptText={'.jpeg, .jpg, .png'}
                    method={'post'}
                    name={'file'}
                    action={'https://docgen-api.logisfleet.com/api/doc-generation-job/upload-file'}
                    headers={{
                      'UploadPath': 'tranzporter/test/attachment/',
                      'Authorization': 'mWU89QAnk0ik'
                    }}
                    maxCount={null}
                    maxSize={null}
                    multiple={true}
                    disabled={true}
                    showDownload={true}
                    canCrop={true}
                    files={multipleFileList}
                    onChange={({ fileList: newFileList }: any) => {
                      setMultipleFileList(newFileList)
                    }}
                  />
                </Col>
              </Row>
              
              <Row className='mb-5'><hr /></Row>

              <Row className='mb-5'>
                <Col xs={12}>
                  <div>base64 - Single</div>
                  <LocalDropzone
                    accept={'image/jpeg,image/jpg,image/png'}
                    acceptText={'.jpeg, .jpg, .png'}
                    maxCount={1}
                    maxSize={null}
                    multiple={false}
                    showDownload={true}
                    canCrop={true}
                    fileList={singleFileList}
                    onChangeFile={(files: any) => {
                      setSingleFileList(files)
                    }}
                  />
                </Col>
                <Col xs={12}>
                  <div>base64 - Max 3 images</div>
                  <LocalDropzone
                    accept={'image/jpeg,image/jpg,image/png'}
                    acceptText={'.jpeg, .jpg, .png'}
                    maxCount={3}
                    maxSize={1}
                    multiple={false}
                    showDownload={true}
                    canCrop={true}
                    fileList={threeFileList}
                    onChangeFile={(files: any) => {
                      setThreeFileList(files)
                    }}
                  />
                </Col>
                <Col xs={12}>
                  <div>base64 - Multiple</div>
                  <LocalDropzone
                    accept={'image/jpeg,image/jpg,image/png'}
                    acceptText={'.jpeg, .jpg, .png'}
                    maxCount={null}
                    maxSize={null}
                    multiple={true}
                    showDownload={false}
                    canCrop={false}
                    fileList={multipleFileList}
                    onChangeFile={(files: any) => {
                      setMultipleFileList(files)
                    }}
                  />
                </Col>
                <Col xs={12}>
                  <div>base64 - Disabled</div>
                  <LocalDropzone
                    accept={'image/jpeg,image/jpg,image/png'}
                    acceptText={'.jpeg, .jpg, .png'}
                    maxCount={null}
                    maxSize={null}
                    multiple={true}
                    disabled={true}
                    showDownload={true}
                    canCrop={true}
                    fileList={multipleFileList}
                    onChangeFile={(files: any) => {
                      setMultipleFileList(files)
                    }}
                  />
                </Col>
              </Row>

            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Image Preview">
            <Accordion.Header>Image Preview</Accordion.Header>
            <Accordion.Body>
              <Row className='mb-5'>
                <Col xs={12}>
                  <Avatar.Group shape='square' className='d-inline-block'>
                    {photos.map((item: any, i: number) => {
                      return <Avatar
                        key={'photo_' + i}
                        style={{ border: '1px solid #F0F0F1', cursor: 'pointer', marginInlineStart: '0px' }} 
                        draggable={false}
                        src={item}
                        onClick={() => {
                          dispatch(imagePreviewSlice.setShow({ items: photos, index: i }));
                        }}
                      />
                    })}
                  </Avatar.Group>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Tabs">
            <Accordion.Header>Tabs</Accordion.Header>
            <Accordion.Body>
              <Row className='mb-5'>
                <Col xs={12}>
                  <Tabs defaultActiveKey="profile">
                    <Tab eventKey="home" title="Home">
                      Tab content for Home
                    </Tab>
                    <Tab eventKey="profile" title="Profile">
                      Tab content for Profile
                    </Tab>
                    <Tab eventKey="contact" title="Contact" disabled>
                      Tab content for Contact
                    </Tab>
                  </Tabs>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Nav">
            <Accordion.Header>Nav</Accordion.Header>
            <Accordion.Body>
              <Row className='mb-5'>
                <Col xs={12}>
                  <Nav
                    activeKey={'nav-2'}
                    onSelect={(eventKey: any) => {
                      
                    }}
                  >
                    <Nav.Link eventKey={'nav-1'}>Driver list</Nav.Link>
                    <Nav.Link eventKey={'nav-2'}>Driver notes</Nav.Link>
                    <Nav.Link eventKey={'nav-3'}>Driver notes</Nav.Link>
                    <Nav.Link eventKey={'nav-4'} disabled>Driver notes</Nav.Link>
                  </Nav>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Button Tab">
            <Accordion.Header>Button Tab</Accordion.Header>
            <Accordion.Body>
              <Row className='g-8 mb-5'>
                <Col xs={'auto'}>
                  <Button variant={'custom-outlined'}>Exchange</Button>
                </Col>
                <Col xs={'auto'}>
                  <Button variant={'custom-outlined'} active>Drop</Button>
                </Col>
                <Col xs={'auto'}>
                  <Button variant={'custom-outlined'}>Exchange</Button>
                </Col>
                <Col xs={'auto'}>
                  <Button variant={'custom-outlined'}>Exchange</Button>
                </Col>
                <Col xs={'auto'}>
                  <Button variant={'custom-outlined'}>Exchange</Button>
                </Col>
                <Col xs={'auto'}>
                  <Button variant={'custom-outlined'}>Exchange</Button>
                </Col>
                <Col xs={'auto'}>
                  <Button variant={'custom-outlined'}>Exchange</Button>
                </Col>
                <Col xs={'auto'}>
                  <Button variant={'custom-outlined'}>Exchange</Button>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Modal">
            <Accordion.Header>Modal</Accordion.Header>
            <Accordion.Body>
              <Row className='mb-5'>
                <Col xs={12}>
                  <div
                    className="modal show"
                    style={{ display: 'block', position: 'initial' }}
                  >
                    <Modal.Dialog>
                      <Modal.Header>
                        <h6 className='fw-medium'>Modal title</h6>
                      </Modal.Header>

                      <Modal.Body>This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?</Modal.Body>

                      <Modal.Footer>
                        <Row className='gx-12'>
                          <Col xs={true}>
                            <Button variant={'custom-outlined'}>Cancel</Button>
                          </Col>
                          <Col xs={'auto'}>
                            <Button variant={'custom-primary'}>Confirm</Button>
                          </Col>
                        </Row>
                      </Modal.Footer>
                    </Modal.Dialog>
                  </div>
                </Col>
                <Col xs={12}>
                  <div
                    className="modal show"
                    style={{ display: 'block', position: 'initial' }}
                  >
                    <Modal.Dialog>
                      <Modal.Header>
                        <h6 className='fw-medium'>Modal title</h6>
                      </Modal.Header>

                      <Modal.Body>This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?</Modal.Body>

                      <Modal.Footer>
                        <Row className='gx-12'>
                          <Col xs={true}>
                            <Button variant={'custom-outlined'}>Cancel</Button>
                          </Col>
                          <Col xs={'auto'}>
                            <Button variant={'custom-danger'}>Confirm</Button>
                          </Col>
                        </Row>
                      </Modal.Footer>
                    </Modal.Dialog>
                  </div>
                </Col>
                <Col xs={12}>
                  <div
                    className="modal show"
                    style={{ display: 'block', position: 'initial' }}
                  >
                    <Modal.Dialog>
                      <Modal.Header className='px-16' closeButton>
                        <h6 className='fw-medium'>API connection</h6>
                      </Modal.Header>

                      <Modal.Body className='px-16'>
                        <div className='card-modal'>
                          <Row className='g-20'>
                            <Col xs={12}>
                              Row 1
                            </Col>
                            <Col xs={12}>
                              Row 2
                            </Col>
                          </Row>
                        </div>
                      </Modal.Body>

                      <Modal.Footer className='bg-white border-top'>
                        <Row className='gx-12'>
                          <Col xs={true}>
                            <Button variant={'custom-outlined'}>Disconnect</Button>
                          </Col>
                          <Col xs={'auto'}>
                            <Button variant={'custom-primary'}>Connect</Button>
                          </Col>
                        </Row>
                      </Modal.Footer>
                    </Modal.Dialog>
                  </div>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Offcanvas">
            <Accordion.Header>Offcanvas</Accordion.Header>
            <Accordion.Body>
              <Row className='mb-5'>
                <Col xs={12}>
                  <Button variant={'custom-primary'}
                    onClick={() => {
                      setShowOffcanvas1(true);
                    }}
                  >Offcanvas 1</Button>

                  <Offcanvas
                    backdrop={'static'}
                    scroll={false}
                    placement={'end'}
                    show={showOffcanvas1}
                    onHide={() => {
                      setShowOffcanvas1(false);
                    }}
                  >
                    <Offcanvas.Header closeButton>
                      <Offcanvas.Title>Offcanvas</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                      <div>
                        This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?
                      </div>
                    </Offcanvas.Body>
                    
                    <Modal.Footer className='border-top'>
                      <Row className='w-100 gx-12'>
                        <Col xs={true}>
                          <Button
                            variant={'custom-secondary'}
                            size={'sm'}
                            onClick={(e) => {
                              setShowOffcanvas1(false);
                            }}
                          >Save and new</Button>
                        </Col>
                        <Col xs={'auto'} className='text-end'>
                          <Button
                            variant={'custom-text'}
                            size={'sm'}
                            className='me-12'
                            onClick={(e) => {
                              setShowOffcanvas1(false);
                            }}
                          >Cancel</Button>
                          <Button
                            variant={'custom-primary'}
                            size={'sm'}
                            onClick={(e) => {
                              setShowOffcanvas1(false);
                            }}
                          >Save</Button>
                        </Col>
                      </Row>
                    </Modal.Footer>
                  </Offcanvas>

                  
                  <Button variant={'custom-primary ms-5'}
                    onClick={() => {
                      setShowOffcanvas2(true);
                    }}
                  >Offcanvas 2</Button>

                  <Offcanvas
                    backdrop={'static'}
                    scroll={false}
                    placement={'end'}
                    show={showOffcanvas2}
                    onHide={() => {
                      setShowOffcanvas2(false);
                    }}
                    style={{ width: '80%' }}
                  >
                    <Offcanvas.Header closeButton>
                      <Offcanvas.Title>Offcanvas</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body className='p-0'>
                      <Row className='g-0'>
                        <Col xs={12} lg={5} xl={4} className='border-end'>
                            <div className='sticky'>
                              <Modal.Body>
                                <div>
                                  This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it? This is the place for capital body text which can be used to convey important and urgent information. Do you understand how to use it?
                                </div>
                              </Modal.Body>
                            </div>

                            <Modal.Footer className='d-none d-lg-block border-top'>
                              <Row className='w-100 gx-12'>
                                <Col xs={true}>
                                  <Button
                                    variant={'custom-secondary'}
                                    size={'sm'}
                                    onClick={(e) => {
                                      setShowOffcanvas2(false);
                                    }}
                                  >Save and new</Button>
                                </Col>
                                <Col xs={'auto'} className='text-end'>
                                  <Button
                                    variant={'custom-text'}
                                    size={'sm'}
                                    className='me-12'
                                    onClick={(e) => {
                                      setShowOffcanvas2(false);
                                    }}
                                  >Cancel</Button>
                                  <Button
                                    variant={'custom-primary'}
                                    size={'sm'}
                                    onClick={(e) => {
                                      setShowOffcanvas2(false);
                                    }}
                                  >Save</Button>
                                </Col>
                              </Row>
                            </Modal.Footer>
                        </Col>
                        <Col xs={12} lg={7} xl={8}>
                          <Modal.Body>
                            <div style={{ height: '2000px' }}>Some text as placeholder. In real life you can have the elements you have chosen.</div>
                            <div>Some text as placeholder.</div>
                          </Modal.Body>
                        </Col>
                      </Row>
                    </Offcanvas.Body>

                    <Modal.Footer className='d-block d-lg-none border-top'>
                      <Row className='w-100 gx-12'>
                        <Col xs={true}>
                          <Button
                            variant={'custom-secondary'}
                            size={'sm'}
                            onClick={(e) => {
                              setShowOffcanvas2(false);
                            }}
                          >Save and new</Button>
                        </Col>
                        <Col xs={'auto'} className='text-end'>
                          <Button
                            variant={'custom-text'}
                            size={'sm'}
                            className='me-12'
                            onClick={(e) => {
                              setShowOffcanvas2(false);
                            }}
                          >Cancel</Button>
                          <Button
                            variant={'custom-primary'}
                            size={'sm'}
                            onClick={(e) => {
                              setShowOffcanvas2(false);
                            }}
                          >Save</Button>
                        </Col>
                      </Row>
                    </Modal.Footer>
                  </Offcanvas>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Toast">
            <Accordion.Header>Toast</Accordion.Header>
            <Accordion.Body>
              <Row className='mb-5'>
                <Col xs={'auto'}>
                  <Button variant={'custom-primary'}
                    onClick={() => {
                      info('Attention', 'Our website under scheduled maintenance tonight from 11 PM to 2 AM.');
                    }}
                  >Info - Attention</Button>
                </Col>

                <Col xs={'auto'}>
                  <Button variant={'custom-primary'}
                    onClick={() => {
                      success('Saved successfully', 'The data you entered has been successfully saved.');
                    }}
                  >Success - Saved successfully</Button>
                </Col>

                <Col xs={'auto'}>
                  <Button variant={'custom-primary'}
                    onClick={() => {
                      success('Updated successfully', 'Your data has been successfully updated.');
                    }}
                  >Success - Updated successfully</Button>
                </Col>
                
                <Col xs={'auto'}>
                  <Button variant={'custom-primary'}
                    onClick={() => {
                      warning('Warning', 'Your subscription is about to expire in 3 days.');
                    }}
                  >Warning</Button>
                </Col>

                <Col xs={'auto'}>
                  <Button variant={'custom-primary'}
                    onClick={() => {
                      danger('Error occurred', 'Sorry, please try again later.');
                    }}
                  >Danger</Button>
                </Col>
                
                <Col xs={'auto'}>
                  <Button variant={'custom-primary'}
                    onClick={() => {
                      toast("Test defalut notification");
                    }}
                  >Defalut</Button>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Alert">
            <Accordion.Header>Alert</Accordion.Header>
            <Accordion.Body>
              <Row className='mb-5'>
                <Col xs={12} className='mb-2'>
                  <Alert
                    message="What is a billing category?"
                    description="Like a chart of account in an accounting software. Billing category allows you to record invoice, purchase transactions and associating billable weight to transactional quantity."
                    type="info"
                    showIcon
                    icon={<AlertInfoIcon />}
                  />
                </Col>
                
                <Col xs={12} className='mb-2'>
                  <Alert
                    message="What is a billing category?"
                    description="Like a chart of account in an accounting software. Billing category allows you to record invoice, purchase transactions and associating billable weight to transactional quantity."
                    type="error"
                    showIcon
                    icon={<AlertCircleIcon />}
                  />
                </Col>

                <Col xs={12} className='mb-2'>
                  <Alert
                    message="What is a billing category?"
                    description="Like a chart of account in an accounting software. Billing category allows you to record invoice, purchase transactions and associating billable weight to transactional quantity."
                    type="warning"
                    showIcon
                    icon={<AlertTriangleIcon />}
                  />
                </Col>

                <Col xs={12}>
                  <Alert
                    message="What is a billing category?"
                    description="Like a chart of account in an accounting software. Billing category allows you to record invoice, purchase transactions and associating billable weight to transactional quantity."
                    type="success"
                    showIcon
                    icon={<AlertCheckIcon />}
                  />
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Progress">
            <Accordion.Header>Progress</Accordion.Header>
            <Accordion.Body>
              <Row className='mb-5'>
                <Col xs={12} md={3}>
                  <Progress className='m-0' percent={30} showInfo={false} />
                </Col>
                <Col xs={12} md={3}>
                  <Progress className='m-0' percent={100} showInfo={false} />
                </Col>
                <Col xs={12} md={3}>
                  <Progress className='m-0' percent={0} status="exception" showInfo={true} />
                </Col>
                <Col xs={12} md={3}>
                  <Progress className='m-0' percent={100} showInfo={true} />
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        
        <Accordion style={{ width: '100%' }} className={'mb-2'}>
          <Accordion.Item eventKey="Table">
            <Accordion.Header>Table</Accordion.Header>
            <Accordion.Body>
              <Row className='mb-5'>

                <Col xs={12}>
                  <div className='card-table'>
                    <Row className='align-items-center g-12'>
                      <Col xs={12} md={4} lg={3} xl={2}>
                        <InputGroup>
                          <InputGroup.Text className='p-search'>
                            <SearchIcon />
                          </InputGroup.Text>
                          <Form.Control
                            type={'text'}
                            autoComplete='off'
                            placeholder={'Search'}
                            isInvalid={false}
                            value={(searchQuery && searchQuery != '') ? searchQuery : ''}
                            onChange={(e: any) => {
                              escapeChars(e);
                              dispatch(tableAlerts.callSetOptions({ 
                                searchQuery: e.target.value,
                                currentPage: 1,
                              }));
                            }}
                            onKeyDown={(e: any) => {
                              escapeChars(e);

                              if (e.key === 'Enter') {
                                dispatch(tableAlerts.callReadPostApi('customer/get-list', null, false, false, () => {}));
                              }
                            }}
                            onPaste={(e: any) => {
                              const pastedText = e.clipboardData.getData('text');
                              const cleanedText = escapeCharsInStringOnPaste(pastedText);
                              dispatch(tableAlerts.callSetOptions({ 
                                searchQuery: cleanedText,
                                currentPage: 1,
                              }));
                              e.preventDefault();
                            }}
                          />
                        </InputGroup>
                      </Col>
                      <Col xs={12} md={true} className='d-none d-md-block'></Col>
                      <Col xs={6} md={'auto'}>
                        <TableFilter
                          onOpen={() => {
                            if(isIncludeInactive == false && isInactive == null){
                              setIsActive(2);
                            } else if(isIncludeInactive == false && isInactive == true){
                              setIsActive(3);
                            } else {
                              setIsActive(1);
                            }
                          }}
                          onUpdate={(state: boolean) => {
                            if(state){
                              if(isActive == 2){
                                dispatch(tableAlerts.callSetOptions({ 
                                  isIncludeInactive: false,
                                  isInactive: null,
                                  currentPage: 1,
                                }));
                                setIsActive(2);
                              } else if(isActive == 3){
                                dispatch(tableAlerts.callSetOptions({ 
                                  isIncludeInactive: false,
                                  isInactive: true,
                                  currentPage: 1,
                                }));
                                setIsActive(3);
                              } else {
                                dispatch(tableAlerts.callSetOptions({ 
                                  isIncludeInactive: true,
                                  isInactive: null,
                                  currentPage: 1,
                                }));
                                setIsActive(1);
                              }
                              
                              dispatch(tableAlerts.callReadPostApi('customer/get-list', null, false, false, () => {}));
                            } else {
                              dispatch(tableAlerts.callSetOptions({ 
                                isIncludeInactive: true,
                                isInactive: null,
                                currentPage: 1,
                              }));
                              setIsActive(1);
                              dispatch(tableAlerts.callReadPostApi('customer/get-list', null, false, false, () => {}));
                            }
                          }}
                        >
                          <Form.Group>
                            <Form.Label>Status</Form.Label>
                            <Form.Control
                              as={Select}
                              value={isActive}
                              placeholder={'Status'}
                              searchable={false}
                              allowClear={false}
                              selectedIcon={true}
                              loading={false}
                              onChangeValue={(value: any, option: any, ref: any) => {
                                setIsActive(value);
                              }}
                              options={[
                                { value: 1, label: 'Any status' },
                                { value: 2, label: 'Active' },
                                { value: 3, label: 'Inactive' },
                              ]}
                            />
                          </Form.Group>
                        </TableFilter>
                      </Col>
                      <Col xs={6} md={'auto'} className='text-end'>
                        <DefaultPopup
                          icon={<SettingsIcon />}
                          text={'Edit columns'}
                          disabled={false}
                        >
                          <DataTableVisibility dataTable={dataTable} />
                        </DefaultPopup>
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col xs={12}>
                  <MaterialDataTable
                    onInit={(t: any) => setDataTable(t)}
                    sliceName={Tables.Alerts}

                    endpoint={'customer/get-list'}
                    method={'post'}
                    firstTimeApiCall={false}
                    rowId={'customerId'}
                    initialParams={{
                      currentPage: 1,
                      pageSize: 10,
                      sortColumn: 'customerName',
                      sortDir: 'asc',
                      searchQuery: null,
                      isIncludeInactive: true,
                      isInactive: null
                    }}
                    initialExtraParams={null}
                    customSortParams={{
                      customerCategoryName: 'category.customerCategoryName',
                    }}

                    columns={columns}
                    columnsRender={columnsRender}
                    renderFallbackValue={'-'}
                    showPagination={true}

                    enableRowSelection={true}
                    enableSorting={true}
                    enableColumnResizing={true}
                    enableColumnOrdering={true}

                    renderDetailPanel={() => {
                      return <div>Detail Panel</div>
                    }}

                    onRowClick={(row: any) => {
                      
                    }}

                    onRowSelection={(selectedRows: any) => {
                      
                    }}

                    onChangeSort={(sortColumn: any, sortDir: any) => {
                      
                    }}
                    onChangeColumnVisibility={(columnVisibility: any) => {
                      
                    }}
                    onChangeColumnSizing={(columnSizing: any) => {
                      
                    }}
                    onChangeColumnOrder={(columnOrder: any) => {
                      
                    }}
                  />
                </Col>
                
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        {/* <Row className='px-2 py-5 g-24'>
          <Col xs={12}>
          <div className='card-table'>
              <Row className='align-items-center g-12'>
                <Col xs={12} md={4} lg={3} xl={2}>
                  <InputGroup>
                    <InputGroup.Text className='p-search'>
                      <SearchIcon />
                    </InputGroup.Text>
                    <Form.Control
                      type={'text'}
                      autoComplete='off'
                      placeholder={'Search'}
                      isInvalid={false}
                      value={(searchQuery && searchQuery != '') ? searchQuery : ''}
                      onChange={(e: any) => {
                        escapeChars(e);
                        dispatch(tableClient.callSetOptions({ 
                          searchQuery: e.target.value,
                          currentPage: 1,
                        }));
                      }}
                      onKeyDown={(e: any) => {
                        escapeChars(e);

                        if (e.key === 'Enter') {
                          dispatch(tableClient.callReadApi('client', null, false, () => {}));
                        }
                      }}
                      onPaste={(e: any) => {
                        const pastedText = e.clipboardData.getData('text');
                        const cleanedText = escapeCharsInStringOnPaste(pastedText);
                        dispatch(tableClient.callSetOptions({ 
                          searchQuery: cleanedText,
                          currentPage: 1,
                        }));
                        e.preventDefault();
                      }}
                    />
                  </InputGroup>
                </Col>
                <Col xs={12} md={true} className='d-none d-md-block'></Col>
                <Col xs={6} md={'auto'}>
                  <TableFilter
                    onOpen={() => {
                      if(isIncludeInactive == false && isInactive == null){
                        setIsActive(2);
                      } else if(isIncludeInactive == false && isInactive == true){
                        setIsActive(3);
                      } else {
                        setIsActive(1);
                      }
                    }}
                    onUpdate={(state: boolean) => {
                      if(state){
                        if(isActive == 2){
                          dispatch(tableClient.callSetOptions({ 
                            isIncludeInactive: false,
                            isInactive: null,
                            currentPage: 1,
                          }));
                          setIsActive(2);
                        } else if(isActive == 3){
                          dispatch(tableClient.callSetOptions({ 
                            isIncludeInactive: false,
                            isInactive: true,
                            currentPage: 1,
                          }));
                          setIsActive(3);
                        } else {
                          dispatch(tableClient.callSetOptions({ 
                            isIncludeInactive: true,
                            isInactive: null,
                            currentPage: 1,
                          }));
                          setIsActive(1);
                        }
                        
                        dispatch(tableClient.callReadApi('client', null, false, () => {}));
                      } else {
                        dispatch(tableClient.callSetOptions({ 
                          isIncludeInactive: true,
                          isInactive: null,
                          currentPage: 1,
                        }));
                        setIsActive(1);
                        dispatch(tableClient.callReadApi('client', null, false, () => {}));
                      }
                    }}
                  >
                    <Form.Group>
                      <Form.Label>Status</Form.Label>
                      <Form.Control
                        as={Select}
                        value={isActive}
                        placeholder={'Status'}
                        searchable={false}
                        allowClear={false}
                        selectedIcon={true}
                        loading={false}
                        onChangeValue={(value: any, option: any, ref: any) => {
                          setIsActive(value);
                        }}
                        options={[
                          { value: 1, label: 'Any status' },
                          { value: 2, label: 'Active' },
                          { value: 3, label: 'Inactive' },
                        ]}
                      />
                    </Form.Group>
                  </TableFilter>
                </Col>
                <Col xs={6} md={'auto'} className='text-end'>
                  <DefaultPopup
                    icon={<SettingsIcon />}
                    text={'Edit columns'}
                    disabled={false}
                  >
                    <DataTableVisibility dataTable={dataTable} />
                  </DefaultPopup>
                </Col>
              </Row>
            </div>
          </Col>
          <Col xs={12}>
          <DataTable<Client>
              onInit={(t: any) => setDataTable(t)}
              sliceName={Tables.Client}

              endpoint={'client'}
              rowId={'clientId'}
              initialParams={{
                currentPage: 1,
                pageSize: 10,
                sortColumn: 'clientName',
                sortDir: 'asc',
                searchQuery: null,
                isIncludeInactive: true,
                isInactive: null
              }}
              initialExtraParams={null}
              customSortParams={{
                clientCategoryName: 'category.clientCategoryName',
                clientPaymentTermName: 'paymentTerm.clientPaymentTermName',
                clientCreditTermName: 'creditTerm.clientCreditTermName',
              }}

              columns={columns}
              columnsRender={columnsRender}
              renderFallbackValue={''}
              
              showHeader={true}
              showPagination={true}

              enableRowSelection={true}
              enableColumnSorting={true}
              enableColumnResizing={true}
              enableColumnOrdering={true}
            />
          </Col>
        </Row> */}

      </Col>
    </Row>

    <ImagePreview />
  </MainContainer>
}

export default DesignSystemPage;
